/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 143);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(50)();
}


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalibratedProduct = exports.RelatedCategory = exports.TechnicalDocumentModal = exports.TechnicalDocument = exports.Popup = exports.LinkedProduct = exports.CheckStockModal = exports.Modal = exports.CheckStockButton = exports.QuantityInput = exports.SearchMessage = exports.PartsListAdded = exports.PartsListModal = exports.CheckStock = exports.ViewBasketButton = exports.AddToBasketButton = exports.PriceBreak = exports.InputSpinner = exports.Image360Carousel = exports.ImageCarousel = undefined;

var _ImageCarousel2 = __webpack_require__(174);

var _ImageCarousel3 = _interopRequireDefault(_ImageCarousel2);

var _Image360Carousel2 = __webpack_require__(176);

var _Image360Carousel3 = _interopRequireDefault(_Image360Carousel2);

var _InputSpinner2 = __webpack_require__(180);

var _InputSpinner3 = _interopRequireDefault(_InputSpinner2);

var _PriceBreak2 = __webpack_require__(181);

var _PriceBreak3 = _interopRequireDefault(_PriceBreak2);

var _AddToBasketButton2 = __webpack_require__(195);

var _AddToBasketButton3 = _interopRequireDefault(_AddToBasketButton2);

var _ViewBasketButton2 = __webpack_require__(208);

var _ViewBasketButton3 = _interopRequireDefault(_ViewBasketButton2);

var _CheckStockModal2 = __webpack_require__(209);

var _CheckStockModal3 = _interopRequireDefault(_CheckStockModal2);

var _PartsListModal2 = __webpack_require__(210);

var _PartsListModal3 = _interopRequireDefault(_PartsListModal2);

var _PartsListAdded2 = __webpack_require__(95);

var _PartsListAdded3 = _interopRequireDefault(_PartsListAdded2);

var _SearchMessage2 = __webpack_require__(211);

var _SearchMessage3 = _interopRequireDefault(_SearchMessage2);

var _QuantityInput2 = __webpack_require__(94);

var _QuantityInput3 = _interopRequireDefault(_QuantityInput2);

var _CheckStockButton2 = __webpack_require__(212);

var _CheckStockButton3 = _interopRequireDefault(_CheckStockButton2);

var _Modal2 = __webpack_require__(31);

var _Modal3 = _interopRequireDefault(_Modal2);

var _LinkedProduct2 = __webpack_require__(213);

var _LinkedProduct3 = _interopRequireDefault(_LinkedProduct2);

var _Popup2 = __webpack_require__(214);

var _Popup3 = _interopRequireDefault(_Popup2);

var _TechnicalDocument2 = __webpack_require__(96);

var _TechnicalDocument3 = _interopRequireDefault(_TechnicalDocument2);

var _TechnicalDocumentModal2 = __webpack_require__(97);

var _TechnicalDocumentModal3 = _interopRequireDefault(_TechnicalDocumentModal2);

var _RelatedCategory2 = __webpack_require__(215);

var _RelatedCategory3 = _interopRequireDefault(_RelatedCategory2);

var _CalibratedProduct2 = __webpack_require__(216);

var _CalibratedProduct3 = _interopRequireDefault(_CalibratedProduct2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ImageCarousel = _ImageCarousel3.default;
exports.Image360Carousel = _Image360Carousel3.default;
exports.InputSpinner = _InputSpinner3.default;
exports.PriceBreak = _PriceBreak3.default;
exports.AddToBasketButton = _AddToBasketButton3.default;
exports.ViewBasketButton = _ViewBasketButton3.default;
exports.CheckStock = _CheckStockModal3.default;
exports.PartsListModal = _PartsListModal3.default;
exports.PartsListAdded = _PartsListAdded3.default;
exports.SearchMessage = _SearchMessage3.default;
exports.QuantityInput = _QuantityInput3.default;
exports.CheckStockButton = _CheckStockButton3.default;
exports.Modal = _Modal3.default;
exports.CheckStockModal = _CheckStockModal3.default;
exports.LinkedProduct = _LinkedProduct3.default;
exports.Popup = _Popup3.default;
exports.TechnicalDocument = _TechnicalDocument3.default;
exports.TechnicalDocumentModal = _TechnicalDocumentModal3.default;
exports.RelatedCategory = _RelatedCategory3.default;
exports.CalibratedProduct = _CalibratedProduct3.default;

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Product = __webpack_require__(199);

Object.defineProperty(exports, 'GetCustomerSpecificPriceBreaks', {
  enumerable: true,
  get: function get() {
    return _Product.GetCustomerSpecificPriceBreaks;
  }
});
Object.defineProperty(exports, 'CheckProductSensitivity', {
  enumerable: true,
  get: function get() {
    return _Product.CheckProductSensitivity;
  }
});

var _Basket = __webpack_require__(200);

Object.defineProperty(exports, 'AddToBasket', {
  enumerable: true,
  get: function get() {
    return _Basket.AddToBasket;
  }
});

var _UserStatus = __webpack_require__(201);

Object.defineProperty(exports, 'RunningTotal', {
  enumerable: true,
  get: function get() {
    return _UserStatus.RunningTotal;
  }
});

var _Analytics = __webpack_require__(202);

Object.defineProperty(exports, 'PublishAddToCartEvent', {
  enumerable: true,
  get: function get() {
    return _Analytics.PublishAddToCartEvent;
  }
});

var _QueryString = __webpack_require__(58);

Object.defineProperty(exports, 'SplitQueryString', {
  enumerable: true,
  get: function get() {
    return _QueryString.SplitQueryString;
  }
});

var _HexDecoder = __webpack_require__(93);

Object.defineProperty(exports, 'DecodeHex', {
  enumerable: true,
  get: function get() {
    return _HexDecoder.DecodeHex;
  }
});

var _Stock = __webpack_require__(203);

Object.defineProperty(exports, 'CheckStock', {
  enumerable: true,
  get: function get() {
    return _Stock.CheckStock;
  }
});

var _PartsList = __webpack_require__(204);

Object.defineProperty(exports, 'SaveToNewPartsList', {
  enumerable: true,
  get: function get() {
    return _PartsList.SaveToNewPartsList;
  }
});
Object.defineProperty(exports, 'SaveToExistingPartsList', {
  enumerable: true,
  get: function get() {
    return _PartsList.SaveToExistingPartsList;
  }
});
Object.defineProperty(exports, 'GetPartsList', {
  enumerable: true,
  get: function get() {
    return _PartsList.GetPartsList;
  }
});

var _HtmlEntities = __webpack_require__(205);

Object.defineProperty(exports, 'HtmlEntitiesDecode', {
  enumerable: true,
  get: function get() {
    return _HtmlEntities.HtmlEntitiesDecode;
  }
});

var _DataLibrary = __webpack_require__(206);

Object.defineProperty(exports, 'GetProductDataLibrary', {
  enumerable: true,
  get: function get() {
    return _DataLibrary.GetProductDataLibrary;
  }
});

var _Date = __webpack_require__(207);

Object.defineProperty(exports, 'FormatDate', {
  enumerable: true,
  get: function get() {
    return _Date.FormatDate;
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(183);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(33);

exports.default = {
  /**
   * Get abstraction for fetch.
   * @return {Promise}
   */
  get: function get(endpoint) {
    return window.fetch(endpoint, {
      method: 'GET',
      headers: new Headers({ Accept: 'application/json' }),
      credentials: 'same-origin'
    }).then(handleResponse, handleError);
  },


  /**
   * Put abstraction for fetch.
   * @return {Promise}
   */
  put: function put(endpoint, body) {
    return window.fetch(endpoint, {
      accept: '*/*',
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json; charset=UTF-8', Accept: 'application/json, text/javascript, */*;' }),
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(handleResponse, handleError);
  },


  /**
   * Post abstraction for fetch.
   * @return {Promise}
   */
  post: function post(endpoint, body) {
    return window.fetch(endpoint, {
      accept: '*/*',
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json; charset=UTF-8', Accept: 'application/json, text/javascript, */*;' }),
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(handleResponse, handleError);
  }
};

/**
 * Handle a response from the server, returning either the JSON if the response is ok or throwing a standardised error
 * object for all non-successful HTTP codes. NB fetch only rejects for networking errors meaning we have to handle these
 * codes here.
 * @param response
 */

function handleResponse(response) {
  if (response.ok) {
    return response.json().catch(function (error) {
      throw {
        status: 0,
        statusText: error.message
      };
    });
  }
  throw {
    status: response.status,
    statusText: response.statusText
  };
}

/**
 * Handle networking errors and throw a standardised error object.
 * @param error
 */
function handleError(error) {
  throw {
    status: 0,
    statusText: error.message
  };
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47).setImmediate))

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = __webpack_require__(21);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function Modal(props) {
  return props.open && _react2.default.createElement(
    'div',
    { key: 0, className: 'modal-overlay' },
    _react2.default.createElement(
      'div',
      {
        className: 'modal',
        tabIndex: '-1',
        role: 'dialog',
        'aria-labelledby': 'rs-modal-title',
        'aria-hidden': 'true',
        'data-keyboard': 'false',
        'data-backdrop': 'static'
      },
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'ease', transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
        props.open && _react2.default.createElement(
          'div',
          { key: 0, className: 'modal-dialog ' + props.className, role: 'document' },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            _react2.default.createElement(
              'div',
              { className: 'modal-header' },
              _react2.default.createElement(
                'button',
                { type: 'button', onClick: function onClick() {
                    return props.onClose();
                  }, className: 'close', 'aria-label': 'Close' },
                _react2.default.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              _react2.default.createElement(
                'h5',
                { className: 'modal-title' },
                props.title
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal-body' },
              props.children
            ),
            props.showFooter && _react2.default.createElement(
              'div',
              { className: 'modal-footer' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  onClick: function onClick() {
                    return props.onClose();
                  },
                  'aria-label': 'Close',
                  className: 'btn btn-secondary btn-cancel',
                  'data-dismiss': 'modal'
                },
                'Close'
              ),
              _react2.default.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-save' },
                'Save changes'
              )
            )
          )
        )
      )
    )
  );
};

Modal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  title: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  showFooter: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

Modal.defaultProps = {
  open: false,
  onClose: null,
  title: '',
  children: null,
  showFooter: false,
  className: ''
};

exports.default = Modal;

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(48);
// On some exotic environments, it's not clear which object `setimmeidate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(25)))

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(51);
var invariant = __webpack_require__(52);
var ReactPropTypesSecret = __webpack_require__(53);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(159);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _Button2 = __webpack_require__(196);

var _Button3 = _interopRequireDefault(_Button2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Button = _Button3.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.SplitQueryString = SplitQueryString;
function parseURI(value) {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch (ex) {
    return '';
  }
}

function SplitQueryString(inputQueryString) {
  var queryString = inputQueryString || window.location.search;
  if (!queryString) return {};

  var items = {};
  return (/^[?#]/.test(queryString) ? queryString.slice(1) : queryString).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    items[key] = !value ? '' : parseURI(value);
    return items;
  }, {});
}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(160);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(153);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(90);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(54);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DecodeHex = DecodeHex;
function DecodeHex(hex) {
  if (!hex) {
    return '';
  }
  var decodedString = '';
  for (var i = 0; i < hex.length; i += 2) {
    decodedString += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }return decodedString;
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuantityInput = function (_React$Component) {
  _inherits(QuantityInput, _React$Component);

  _createClass(QuantityInput, null, [{
    key: 'preventDefaultAction',
    value: function preventDefaultAction(event) {
      event.preventDefault();
    }
  }]);

  function QuantityInput(props) {
    _classCallCheck(this, QuantityInput);

    var _this = _possibleConstructorReturn(this, (QuantityInput.__proto__ || Object.getPrototypeOf(QuantityInput)).call(this, props));

    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  _createClass(QuantityInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ value: props.value });
    }
  }, {
    key: 'changeInputValue',
    value: function changeInputValue(event) {
      var newValue = String(event.target.value).replace(/[\uFF10-\uFF19]/g, function (ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 65248);
      });

      newValue = newValue === '' ? newValue : Number(newValue);

      if (newValue !== '' && (!newValue || newValue % 1 !== 0 || newValue > this.props.maximumQuantity)) {
        return;
      }

      if (this.props.onChangeHandler !== undefined) {
        this.props.onChangeHandler(newValue);
      }

      this.setState({
        value: newValue
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('input', {
        type: 'text',
        className: this.props.className,
        value: this.state.value,
        onPaste: function onPaste(event) {
          return QuantityInput.preventDefaultAction(event);
        },
        onDrop: function onDrop(event) {
          return QuantityInput.preventDefaultAction(event);
        },
        onChange: function onChange(event) {
          return _this2.changeInputValue(event);
        },
        autoComplete: 'off',
        maxLength: this.props.maximumQuantity
      });
    }
  }]);

  return QuantityInput;
}(_react2.default.Component);

exports.default = QuantityInput;


QuantityInput.propTypes = {
  maximumQuantity: _propTypes2.default.number.isRequired,
  onChangeHandler: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  className: _propTypes2.default.string
};

QuantityInput.defaultProps = {
  onUpdateQuantity: undefined,
  onChangeHandler: undefined,
  value: 0,
  className: ''
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PartsListAdded = function PartsListAdded(props) {
  return _react2.default.createElement(
    'div',
    { className: 'parts-list', id: 'parts-list-added' },
    _react2.default.createElement(
      'div',
      { className: 'parts-title parts-list-added-msg' },
      _react2.default.createElement('i', { className: 'table-cell icon icon-rs_57-tick', 'aria-hidden': 'true' }),
      _react2.default.createElement(
        'span',
        null,
        props.successMessage
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'product table' },
      _react2.default.createElement(
        'span',
        { className: 'added-quantity table-cell' },
        props.addedQuantity
      ),
      _react2.default.createElement(
        'div',
        { className: 'product-details table-cell' },
        _react2.default.createElement(
          'div',
          null,
          props.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'rsStockNumberDiv' },
          _react2.default.createElement(
            'span',
            null,
            props.stockNumber
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'mpnNumberDiv' },
          _react2.default.createElement(
            'span',
            null,
            props.manufacturerPartNumber
          )
        )
      )
    ),
    _react2.default.createElement('hr', null),
    _react2.default.createElement(
      'div',
      { className: 'buttons' },
      _react2.default.createElement(
        'button',
        { className: 'btn btn-default', onClick: props.closeModal },
        props.labels.close
      ),
      '\xA0',
      _react2.default.createElement(
        'a',
        { href: props.partsListDetailsUrl, className: 'btn btn-secondary-blue btn-view-parts-list' },
        props.labels.viewList
      )
    )
  );
};

PartsListAdded.propTypes = {
  name: _propTypes2.default.string,
  stockNumber: _propTypes2.default.string,
  manufacturerPartNumber: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    addedToPartsList: _propTypes2.default.string,
    close: _propTypes2.default.string,
    viewList: _propTypes2.default.string
  }),
  successMessage: _propTypes2.default.string,
  addedQuantity: _propTypes2.default.number,
  closeModal: _propTypes2.default.func,
  partsListDetailsUrl: _propTypes2.default.string
};

PartsListAdded.defaultProps = {
  name: '',
  stockNumber: '',
  manufacturerPartNumber: '',
  labels: {},
  successMessage: null,
  addedQuantity: null,
  closeModal: null,
  viewList: null,
  partsListDetailsUrl: null
};

exports.default = PartsListAdded;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TechnicalDocument = function TechnicalDocument(props) {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'tr',
      null,
      _react2.default.createElement(
        'td',
        { className: 'icon-cell' },
        _react2.default.createElement('span', { className: 'icon ' + (props.revisions.extension === 'pdf' ? 'icon-rs_33-file-pdf' : 'icon-rs_137-zip') })
      ),
      _react2.default.createElement(
        'td',
        { className: 'title-cell' },
        _react2.default.createElement(
          'a',
          {
            href: props.href
          },
          props.title
        )
      ),
      _react2.default.createElement(
        'td',
        { className: 'update-cell' },
        props.revisions.created
      ),
      _react2.default.createElement(
        'td',
        { className: 'revision-cell' },
        props.latestRevision
      ),
      _react2.default.createElement(
        'td',
        { className: 'language-cell' },
        props.language
      )
    )
  );
};

TechnicalDocument.propTypes = {
  title: _propTypes2.default.string,
  created: _propTypes2.default.number,
  language: _propTypes2.default.string,
  latestRevision: _propTypes2.default.number,
  revisions: _propTypes2.default.shape({
    path: _propTypes2.default.string,
    revision: _propTypes2.default.number,
    manufacturerRevision: _propTypes2.default.string,
    extension: _propTypes2.default.string,
    size: _propTypes2.default.number,
    created: _propTypes2.default.string
  }),
  href: _propTypes2.default.string
};

TechnicalDocument.defaultProps = {
  title: '',
  created: 0,
  language: '',
  latestRevision: 0,
  revisions: {},
  href: ''
};

exports.default = TechnicalDocument;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TechnicalDocument = __webpack_require__(96);

var _TechnicalDocument2 = _interopRequireDefault(_TechnicalDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TechnicalDocumentModal = function TechnicalDocumentModal(props) {
  return _react2.default.createElement(
    'div',
    { id: 'documentListCont', className: 'documentListContainer' },
    _react2.default.createElement(
      'div',
      { className: 'documentListHeader' },
      _react2.default.createElement(
        'span',
        { className: 'bold right20' },
        props.labels.rsUpdate
      ),
      _react2.default.createElement(
        'span',
        { className: 'bold right20' },
        props.labels.revision
      ),
      _react2.default.createElement(
        'span',
        { className: 'bold' },
        props.labels.language
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'docSection', id: 'technical-section' },
      _react2.default.createElement(
        'div',
        { className: 'docSectionTitle' },
        props.labels.technicalDocuments
      ),
      _react2.default.createElement(
        'table',
        { className: 'docListTable', border: '0', width: '100%' },
        _react2.default.createElement(
          'tbody',
          null,
          props.documents.map(function (document) {
            return _react2.default.createElement(_TechnicalDocument2.default, _extends({ key: document.id }, document));
          })
        )
      )
    )
  );
};

TechnicalDocumentModal.propTypes = {
  labels: _propTypes2.default.shape({
    rsUpdate: _propTypes2.default.string,
    revision: _propTypes2.default.string,
    language: _propTypes2.default.string,
    technicalDocuments: _propTypes2.default.string
  }),
  documents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    title: _propTypes2.default.string,
    created: _propTypes2.default.number,
    updated: _propTypes2.default.number,
    language: _propTypes2.default.string,
    latestRevision: _propTypes2.default.number,
    type: _propTypes2.default.string,
    format: _propTypes2.default.string,
    revisions: _propTypes2.default.shape({
      path: _propTypes2.default.string,
      revision: _propTypes2.default.number,
      manufacturerRevision: _propTypes2.default.string,
      extension: _propTypes2.default.string,
      size: _propTypes2.default.number,
      created: _propTypes2.default.string
    }),
    href: _propTypes2.default.string
  }))
};

TechnicalDocumentModal.defaultProps = {
  labels: {},
  documents: []
};

exports.default = TechnicalDocumentModal;

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
module.exports = __webpack_require__(235);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactRedux = __webpack_require__(49);

var _redux = __webpack_require__(55);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _browserCheck = __webpack_require__(170);

var _containers = __webpack_require__(172);

var _store = __webpack_require__(231);

var _store2 = _interopRequireDefault(_store);

var _middleware = __webpack_require__(233);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_store2.default, _middleware.initialImageCarouselState);
var calibrationAlternativesDisplayEnabled = rs.web.product.model.calibrationAlternativesDisplayEnabled;

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  window.cloudinary && (0, _browserCheck.checkBrowser)() ? _react2.default.createElement(_containers.Image360CarouselContainer, null) : _react2.default.createElement(_containers.ImageCarouselContainer, null)
), document.getElementById('image-carousel'));

if (document.getElementById('price-break-container')) _reactDom2.default.render(_react2.default.createElement(_containers.PriceBreakContainer, null), document.getElementById('price-break-container'));
_reactDom2.default.render(_react2.default.createElement(_containers.SearchMessageContainer, null), document.getElementById('search-message-container'));
_reactDom2.default.render(_react2.default.createElement(_containers.LinkedProductContainer, null), document.getElementById('linked-products-container'));
_reactDom2.default.render(_react2.default.createElement(_containers.TechnicalDocumentContainer, null), document.getElementById('technical-document-container'));
_reactDom2.default.render(_react2.default.createElement(_containers.RelatedCategoryContainer, null), document.getElementById('related-category-container'));
if (calibrationAlternativesDisplayEnabled) _reactDom2.default.render(_react2.default.createElement(_containers.CalibratedProductContainer, null), document.getElementById('calibrated-products-container'));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(168);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(89);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(156);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(154);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(86);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(158);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(162);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(161)(module)))

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(87);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(89);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(169);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(54);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkBrowser = undefined;

var _bowser = __webpack_require__(171);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var browser = _bowser2.default.getParser(window.navigator.userAgent);

var checkBrowser = exports.checkBrowser = function checkBrowser() {
  return browser.satisfies({
    desktop: {
      chrome: '>=60',
      firefox: '>=60',
      edge: '>=15',
      opera: '>=50',
      safari: '>=10.1'
    },
    tablet: {
      chrome: '>=76',
      safari: '>=11'
    }
  });
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map(function(e){return parseInt(e,10)||0});if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map(function(e){return parseInt(e,10)||0});if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),function(e){return new Array(20-e.length).join("0")+e}).reverse()});for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=n.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=i.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=s.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=a.default.find(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some(function(t){return e.test(t)});throw new Error("Browser's test function is not valid")});return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return Object.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach(function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)}),n>0){var a=Object.keys(r),o=a.find(function(e){return t.isOS(e)});if(o){var u=this.satisfies(r[o]);if(void 0!==u)return u}var d=a.find(function(e){return t.isPlatform(e)});if(d){var c=this.satisfies(r[d]);if(void 0!==c)return c}}if(s>0){var f=Object.keys(i).find(function(e){return t.isBrowser(e,!0)});if(void 0!==f)return this.compareVersion(i[f])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e){return this.isBrowser(e)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some(function(e){return t.is(e)})},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s\/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s\/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s\/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s\/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s\/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s\/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows/i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s\/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[\/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalibratedProductContainer = exports.RelatedCategoryContainer = exports.TechnicalDocumentContainer = exports.LinkedProductContainer = exports.SearchMessageContainer = exports.PriceBreakContainer = exports.ImageCarouselContainer = exports.Image360CarouselContainer = undefined;

var _Image360Carousel = __webpack_require__(173);

var _Image360Carousel2 = _interopRequireDefault(_Image360Carousel);

var _ImageCarousel = __webpack_require__(217);

var _ImageCarousel2 = _interopRequireDefault(_ImageCarousel);

var _PriceBreak = __webpack_require__(218);

var _PriceBreak2 = _interopRequireDefault(_PriceBreak);

var _SearchMessageContainer2 = __webpack_require__(224);

var _SearchMessageContainer3 = _interopRequireDefault(_SearchMessageContainer2);

var _LinkedProduct = __webpack_require__(226);

var _LinkedProduct2 = _interopRequireDefault(_LinkedProduct);

var _TechnicalDocument = __webpack_require__(227);

var _TechnicalDocument2 = _interopRequireDefault(_TechnicalDocument);

var _RelatedCategory = __webpack_require__(229);

var _RelatedCategory2 = _interopRequireDefault(_RelatedCategory);

var _CalibratedProduct = __webpack_require__(230);

var _CalibratedProduct2 = _interopRequireDefault(_CalibratedProduct);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Image360CarouselContainer = _Image360Carousel2.default;
exports.ImageCarouselContainer = _ImageCarousel2.default;
exports.PriceBreakContainer = _PriceBreak2.default;
exports.SearchMessageContainer = _SearchMessageContainer3.default;
exports.LinkedProductContainer = _LinkedProduct2.default;
exports.TechnicalDocumentContainer = _TechnicalDocument2.default;
exports.RelatedCategoryContainer = _RelatedCategory2.default;
exports.CalibratedProductContainer = _CalibratedProduct2.default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(49);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image360CarouselContainer = function Image360CarouselContainer(props) {
  return _react2.default.createElement(_components.Image360Carousel, {
    images: props.images,
    shared: props.shared,
    video: props.video,
    vfmFlagImages: props.vfmFlagImages,
    is360Display: props.is360Display,
    productGalleryContentCloudName: props.productGalleryContentCloudName,
    productNumber: props.productNumber
  });
};

Image360CarouselContainer.propTypes = {
  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string.isRequired,
    largeImageURL: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  })).isRequired,
  shared: _propTypes2.default.shape({
    isShared: _propTypes2.default.bool.isRequired,
    sharedMessage: _propTypes2.default.string.isRequired
  }).isRequired,
  video: _propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string,
    videoURL: _propTypes2.default.string
  }).isRequired,
  vfmFlagImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imageURL: _propTypes2.default.string.isRequired,
    imageName: _propTypes2.default.string.isRequired,
    hoverText: _propTypes2.default.string.isRequired
  })).isRequired,
  is360Display: _propTypes2.default.bool.isRequired,
  productGalleryContentCloudName: _propTypes2.default.string.isRequired,
  productNumber: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    images: state.ImageCarousel.images,
    shared: state.ImageCarousel.shared,
    video: state.ImageCarousel.video,
    vfmFlagImages: state.ImageCarousel.vfmFlagImages,
    is360Display: state.ImageCarousel.is360Display,
    productGalleryContentCloudName: state.ImageCarousel.productGalleryContentCloudName,
    productNumber: state.ImageCarousel.productNumber
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Image360CarouselContainer);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Thumbnail = __webpack_require__(175);

var _Thumbnail2 = _interopRequireDefault(_Thumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageCarousel = function (_React$Component) {
  _inherits(ImageCarousel, _React$Component);

  function ImageCarousel(props) {
    _classCallCheck(this, ImageCarousel);

    var _this = _possibleConstructorReturn(this, (ImageCarousel.__proto__ || Object.getPrototypeOf(ImageCarousel)).call(this, props));

    _this.state = {
      selectedImageIndex: 0,
      currentPosition: 0,
      isVideoDisplayed: false
    };
    _this.onVideoSelected = _this.onVideoSelected.bind(_this);
    return _this;
  }

  _createClass(ImageCarousel, [{
    key: 'onSelectedImageIndexChanged',
    value: function onSelectedImageIndexChanged(newSelectedImageIndex) {
      this.setState({
        isVideoDisplayed: false,
        selectedImageIndex: newSelectedImageIndex
      });
    }
  }, {
    key: 'onMoveCarousel',
    value: function onMoveCarousel(direction) {
      var newCurrentPosition = this.state.currentPosition + direction;
      if (newCurrentPosition + this.props.maxCarouselSize > this.props.images.length || newCurrentPosition < 0) {
        return;
      }

      this.setState({
        currentPosition: newCurrentPosition
      });
    }
  }, {
    key: 'onVideoSelected',
    value: function onVideoSelected() {
      this.setState({
        isVideoDisplayed: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'images' },
        _react2.default.createElement(
          'div',
          { className: 'thumbs-frame' },
          _react2.default.createElement(
            'div',
            { className: 'col-thumbnail' },
            this.props.images.length > this.props.maxCarouselSize && _react2.default.createElement(
              'div',
              { className: 'nav-up', onClick: function onClick() {
                  return _this2.onMoveCarousel(-1);
                }, role: 'button', tabIndex: 0 },
              _react2.default.createElement(
                'span',
                { className: 'thumbnail-nav ' + (this.state.currentPosition > 0 ? '' : 'disabled') },
                _react2.default.createElement('span', { className: 'icon icon-rs_22-chev-up' })
              )
            ),
            (this.props.images.length > 1 || this.props.images.length === 1 && this.props.images[0].thumbnailURL) && this.props.images.slice(this.state.currentPosition, this.props.maxCarouselSize + this.state.currentPosition).map(function (image) {
              return _react2.default.createElement(_Thumbnail2.default, {
                image: image,
                key: image.id,
                index: image.id,
                selectedImageIndexChanged: function selectedImageIndexChanged(newSelectedImage) {
                  _this2.onSelectedImageIndexChanged(newSelectedImage);
                },
                selectedImageIndex: _this2.state.selectedImageIndex
              });
            }),
            this.props.images.length > this.props.maxCarouselSize && _react2.default.createElement(
              'div',
              { className: 'nav-down', onClick: function onClick() {
                  return _this2.onMoveCarousel(1);
                }, role: 'button', tabIndex: -1 },
              _react2.default.createElement(
                'span',
                {
                  className: 'thumbnail-nav\n                  ' + (this.state.currentPosition + this.props.maxCarouselSize !== this.props.images.length ? '' : 'disabled')
                },
                _react2.default.createElement('span', { className: 'icon icon-rs_19-chev-down' })
              )
            ),
            this.props.video.videoURL && _react2.default.createElement(
              'div',
              { className: 'video-thumbnail-container', onClick: this.onVideoSelected, role: 'button', tabIndex: -1 },
              _react2.default.createElement(
                'span',
                { className: 'thumbnail-img video' },
                _react2.default.createElement('img', { className: 'video-thumbnail-image', src: this.props.video.thumbnailURL, alt: '' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-enlarge' },
          !this.state.isVideoDisplayed && this.props.images.length > 0 && _react2.default.createElement('img', { id: 'mainImage', src: this.props.images[this.state.selectedImageIndex].largeImageURL, alt: 'Main Product' }),
          this.state.isVideoDisplayed && _react2.default.createElement('iframe', {
            title: this.props.video.videoURL,
            id: 'mainVideo',
            src: this.props.video.videoURL,
            frameBorder: '0',
            wmode: 'opaque'
          }),
          this.props.shared.isShared && _react2.default.createElement(
            'div',
            { className: 'supporting-text' },
            this.props.shared.sharedMessage
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'vfm-flags-images-container' },
          this.props.vfmFlagImages.map(function (_ref) {
            var id = _ref.id,
                imageURL = _ref.imageURL,
                hoverText = _ref.hoverText,
                imageName = _ref.imageName;
            return _react2.default.createElement(
              'span',
              { key: id },
              _react2.default.createElement('img', {
                className: 'vfm-flags-image',
                src: imageURL,
                title: hoverText,
                alt: imageName
              })
            );
          })
        )
      );
    }
  }]);

  return ImageCarousel;
}(_react2.default.Component);

exports.default = ImageCarousel;

ImageCarousel.propTypes = {
  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string.isRequired,
    largeImageURL: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  })).isRequired,
  maxCarouselSize: _propTypes2.default.number.isRequired,
  shared: _propTypes2.default.shape({
    isShared: _propTypes2.default.bool.isRequired,
    sharedMessage: _propTypes2.default.string.isRequired
  }).isRequired,
  video: _propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string,
    videoURL: _propTypes2.default.string
  }).isRequired,
  vfmFlagImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imageURL: _propTypes2.default.string.isRequired,
    imageName: _propTypes2.default.string.isRequired,
    hoverText: _propTypes2.default.string.isRequired
  })).isRequired
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Thumbnail = function Thumbnail(props) {
  return _react2.default.createElement(
    'div',
    { className: 'thumbnail pic-' + props.index, key: props.index },
    _react2.default.createElement(
      'span',
      {
        onClick: function onClick() {
          return props.selectedImageIndexChanged(props.index);
        },
        role: 'button',
        tabIndex: -1,
        className: 'thumbnail-img ' + (props.image.id === props.selectedImageIndex ? 'selected' : '')
      },
      _react2.default.createElement('img', { src: props.image.thumbnailURL, alt: '' })
    )
  );
};

Thumbnail.propTypes = {
  image: _propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string.isRequired,
    largeImageURL: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  index: _propTypes2.default.number.isRequired,
  selectedImageIndexChanged: _propTypes2.default.func.isRequired,
  selectedImageIndex: _propTypes2.default.number.isRequired
};

exports.default = Thumbnail;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(177);

var _classnames2 = _interopRequireDefault(_classnames);

var _cloudinary = __webpack_require__(178);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image360Carousel = function (_React$Component) {
  _inherits(Image360Carousel, _React$Component);

  function Image360Carousel(props) {
    _classCallCheck(this, Image360Carousel);

    var _this = _possibleConstructorReturn(this, (Image360Carousel.__proto__ || Object.getPrototypeOf(Image360Carousel)).call(this, props));

    _this.state = {
      isVideoDisplayed: false,
      isSingleImage: false
    };
    _this.onVideoSelected = _this.onVideoSelected.bind(_this);
    return _this;
  }

  _createClass(Image360Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // check to see if we have one image and that image contains http - hence a reverse proxy image
      if (this.props.images.length === 1 && this.props.images[0].largeImageURL.indexOf('http') > -1) {
        this.setState({
          isSingleImage: true
        });
      } else {
        var localMediaAssets = [];

        this.props.images.forEach(function (image) {
          localMediaAssets.push({ publicId: image.thumbnailURL.substring(image.thumbnailURL.lastIndexOf('/') + 1).replace('.jpg', ''), mediaType: 'image' });
        });

        if (this.props.is360Display) {
          localMediaAssets.push({ tag: this.props.productNumber, mediaType: 'spin' });
        }

        _cloudinary.productGalleryContent.mediaAssets = localMediaAssets;
        _cloudinary.productGalleryContent.cloudName = this.props.productGalleryContentCloudName;

        if (localMediaAssets.length > 0) {
          var productGallery = window.cloudinary.galleryWidget(_cloudinary.productGalleryContent);
          productGallery.render();

          productGallery.on('thumbclick', function () {
            _this2.setState({
              isVideoDisplayed: false
            });
          });
        }
      }
    }
  }, {
    key: 'onVideoSelected',
    value: function onVideoSelected() {
      this.setState({
        isVideoDisplayed: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'images' },
        this.props.images.length > 0 && !this.state.isSingleImage && _react2.default.createElement('div', {
          id: 'productGallery',
          className: '' + (this.props.vfmFlagImages.length === 0 ? 'product-gallery product-gallery-full' : 'product-gallery')
        }),
        this.props.vfmFlagImages.length > 0 && _react2.default.createElement(
          'div',
          { className: 'vfm-flags-images-container' },
          this.props.vfmFlagImages.map(function (_ref) {
            var id = _ref.id,
                imageURL = _ref.imageURL,
                hoverText = _ref.hoverText,
                imageName = _ref.imageName;
            return _react2.default.createElement(
              'span',
              { key: id },
              _react2.default.createElement('img', {
                className: 'vfm-flags-image',
                src: imageURL,
                title: hoverText,
                alt: imageName
              })
            );
          })
        ),
        this.state.isSingleImage && _react2.default.createElement('img', { id: 'mainImage', src: this.props.images[0].largeImageURL, alt: 'Main Product' }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({
              'image-content-padding-left ': this.props.images.length > 0 && !this.state.isSingleImage,
              'vfm-content-padding-right ': this.props.vfmFlagImages.length > 0
            })
          },
          this.props.shared.isShared && _react2.default.createElement(
            'div',
            { className: 'supporting-text' },
            this.props.shared.sharedMessage
          ),
          _react2.default.createElement(
            'div',
            { className: 'viewer-3d-video-container' },
            this.props.video.videoURL && _react2.default.createElement(
              'div',
              {
                className: 'video-container video-container',
                onClick: this.onVideoSelected,
                role: 'button',
                tabIndex: -1
              },
              _react2.default.createElement(
                'span',
                { className: 'video' },
                _react2.default.createElement('img', {
                  className: 'video-image',
                  src: this.props.video.thumbnailURL,
                  alt: ''
                })
              )
            )
          )
        ),
        this.state.isVideoDisplayed && _react2.default.createElement(
          'div',
          { className: '' + (this.props.vfmFlagImages.length === 0 ? 'video-3d-content video-3d-content-full' : 'video-3d-content') },
          _react2.default.createElement('iframe', {
            title: this.props.video.videoURL,
            id: 'mainVideo',
            className: 'main-video-3d-viewer',
            src: this.props.video.videoURL,
            frameBorder: '0',
            wmode: 'opaque'
          })
        )
      );
    }
  }]);

  return Image360Carousel;
}(_react2.default.Component);

exports.default = Image360Carousel;

Image360Carousel.propTypes = {
  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string.isRequired,
    largeImageURL: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  })).isRequired,
  shared: _propTypes2.default.shape({
    isShared: _propTypes2.default.bool.isRequired,
    sharedMessage: _propTypes2.default.string.isRequired
  }).isRequired,
  video: _propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string,
    videoURL: _propTypes2.default.string
  }).isRequired,
  vfmFlagImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imageURL: _propTypes2.default.string.isRequired,
    imageName: _propTypes2.default.string.isRequired,
    hoverText: _propTypes2.default.string.isRequired
  })).isRequired,
  is360Display: _propTypes2.default.bool.isRequired,
  productGalleryContentCloudName: _propTypes2.default.string.isRequired,
  productNumber: _propTypes2.default.string.isRequired
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _productGalleryContent = __webpack_require__(179);

Object.defineProperty(exports, 'productGalleryContent', {
  enumerable: true,
  get: function get() {
    return _productGalleryContent.productGalleryContent;
  }
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var productGalleryContent = exports.productGalleryContent = {
  container: '#productGallery',
  cloudName: '', // populated in components/image360Carousel
  mediaAssets: [], // populated in components/image360Carousel
  carouselStyle: 'thumbnails',
  carouselLocation: 'left',
  navigation: 'none',
  aspectRatio: '16:9',
  thumbnailProps: {
    width: 112,
    height: 96,
    mediaSymbolPosition: 'center',
    mediaSymbolBgShape: 'radius',
    selectedStyle: 'border',
    selectedBorderColor: '#d0021b',
    selectedBorderPosition: 'all',
    selectedBorderWidth: 1,
    mediaSymbolBgOpacity: 0.8
  },
  zoom: true,
  zoomProps: {
    level: 2.5
  },
  themeProps: {
    primary: '#ffffff',
    onPrimary: '#000000',
    active: '#d0021b'
  },
  transition: 'none',
  viewportBreakpoints: []
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputSpinner = function (_React$Component) {
  _inherits(InputSpinner, _React$Component);

  function InputSpinner(props) {
    _classCallCheck(this, InputSpinner);

    var _this = _possibleConstructorReturn(this, (InputSpinner.__proto__ || Object.getPrototypeOf(InputSpinner)).call(this, props));

    _this.state = {
      value: _this.props.initialQuantity
    };
    return _this;
  }

  _createClass(InputSpinner, [{
    key: 'changeHandler',
    value: function changeHandler(newValue) {
      this.setState({
        value: newValue
      });

      if (this.props.onUpdateQuantity !== undefined) {
        this.props.onUpdateQuantity(newValue);
      }
    }
  }, {
    key: 'stepQuantity',
    value: function stepQuantity(packSizeStep) {
      var newValue = this.state.value;
      newValue = newValue || 0;

      var remainder = newValue % packSizeStep;

      if (remainder !== 0) {
        newValue = packSizeStep > 0 ? Math.ceil(newValue / packSizeStep) * packSizeStep : Math.floor(newValue / Math.abs(packSizeStep)) * Math.abs(packSizeStep);
      } else {
        newValue += packSizeStep;
      }

      if (newValue <= 0 || newValue > this.props.maximumQuantity) {
        return;
      }

      this.changeHandler(newValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'input-group spinner' },
        _react2.default.createElement(_.QuantityInput, {
          maximumQuantity: this.props.maximumQuantity,
          onChangeHandler: function onChangeHandler(newValue) {
            return _this2.changeHandler(newValue);
          },
          value: this.state.value,
          className: 'form-control'
        }),
        _react2.default.createElement(
          'div',
          { className: 'input-group-btn-vertical' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-default',
              type: 'button',
              onClick: function onClick() {
                return _this2.stepQuantity(_this2.props.packSize);
              }
            },
            _react2.default.createElement('i', { className: 'icon icon-rs_82-pointer-up' })
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-default',
              type: 'button',
              onClick: function onClick() {
                return _this2.stepQuantity(-_this2.props.packSize);
              }
            },
            _react2.default.createElement('i', { className: 'icon icon-rs_45-pointer-down' })
          )
        )
      );
    }
  }]);

  return InputSpinner;
}(_react2.default.Component);

exports.default = InputSpinner;

InputSpinner.propTypes = {
  initialQuantity: _propTypes2.default.number.isRequired,
  packSize: _propTypes2.default.number.isRequired,
  maximumQuantity: _propTypes2.default.number.isRequired,
  onUpdateQuantity: _propTypes2.default.func
};

InputSpinner.defaultProps = {
  onUpdateQuantity: undefined
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EnergyLabel = __webpack_require__(182);

var _EnergyLabel2 = _interopRequireDefault(_EnergyLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PriceBreak = function (_React$Component) {
  _inherits(PriceBreak, _React$Component);

  function PriceBreak() {
    _classCallCheck(this, PriceBreak);

    return _possibleConstructorReturn(this, (PriceBreak.__proto__ || Object.getPrototypeOf(PriceBreak)).apply(this, arguments));
  }

  _createClass(PriceBreak, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateEnergyLabelLink(); // Wait for energy label doc to load in main page
    }
  }, {
    key: 'getRoundedQuantity',
    value: function getRoundedQuantity() {
      return Math.floor(this.props.quantity / this.props.packSize) * this.props.packSize;
    }

    // Wait for the documents to be rendered, then update the product info sheet link

  }, {
    key: 'updateEnergyLabelLink',
    value: function updateEnergyLabelLink() {
      var self = this;
      function tryUpdateLink() {
        var productInfoSheet = document.getElementById('energy-info-sheet-link');
        if (productInfoSheet) {
          self.props.energyProductInfoSheetLink = productInfoSheet.href;
          var theLink = document.getElementById('energy-label-product-information-link');
          if (theLink) {
            theLink.href = self.props.energyProductInfoSheetLink;
          }
          return true;
        }
        return false;
      }
      if (!tryUpdateLink()) {
        // Not there yet
        var observer = new MutationObserver(function () {
          if (tryUpdateLink()) {
            observer.disconnect();
          }
        });
        observer.observe(document, { childList: true, subtree: true });
      }
      return true;
    }
  }, {
    key: 'priceBreakRender',
    value: function priceBreakRender(priceBreak, index, selectedPriceBreakIndex) {
      var isRowSelected = index === selectedPriceBreakIndex;
      return _react2.default.createElement(
        'div',
        {
          className: 'table-row value-row ' + (isRowSelected ? 'price-range-bg' : ''),
          id: 'value-row-' + priceBreak.priceBreakRange,
          key: priceBreak.priceBreakRange
        },
        _react2.default.createElement(
          'div',
          {
            className: 'breakRangeWithoutUnit col-xs-' + this.props.colSize
          },
          priceBreak.priceBreakRange
        ),
        _react2.default.createElement(
          'div',
          { className: 'unitPrice col-xs-' + this.props.colSize + ' ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '') },
          priceBreak.priceExVat
        ),
        this.props.showIndicativePrices && _react2.default.createElement(
          'div',
          { className: 'indicativePrice col-xs-' + this.props.colSize + ' ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '') },
          priceBreak.indicativePriceExVat
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var maxCombinedPriceLength = 20;
      var selectedPriceBreakIndex = 0;
      this.props.priceBreaks.forEach(function (priceBreak, index) {
        if ((_this2.getRoundedQuantity() >= priceBreak.priceBreakLowerBound || _this2.getRoundedQuantity() < priceBreak.priceBreakLowerBound && index === 0) && (_this2.getRoundedQuantity() <= priceBreak.priceBreakUpperBound || !priceBreak.priceBreakUpperBound)) {
          selectedPriceBreakIndex = index;
        }
      });
      var willPricesOverlap = (this.props.productPrice.currencySymbol + this.props.priceBreaks[selectedPriceBreakIndex].priceExVatWithoutCurrencySymbol.toString() + this.props.productPrice.currencySymbol + this.props.priceBreaks[selectedPriceBreakIndex].priceIncVatWithoutCurrencySymbol.toString()).length > maxCombinedPriceLength;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'topPriceArea' },
          _react2.default.createElement(
            'div',
            { className: 'txt' },
            this.props.labels.linePriceHeaderLabel
          ),
          this.props.productPrice.wasPrice && !this.props.isCustomerSpecificPricing && _react2.default.createElement(
            'div',
            { className: 'was-price' },
            this.props.labels.wasPriceLabel,
            _react2.default.createElement(
              'span',
              null,
              this.props.productPrice.wasPrice
            )
          ),
          this.props.priceBreaks[selectedPriceBreakIndex].wasPriceExVat && this.props.isCustomerSpecificPricing && _react2.default.createElement(
            'div',
            { className: 'was-price-csp' },
            _react2.default.createElement(
              'span',
              { className: 'was-price-csp-label' },
              this.props.labels.wasPriceLabel
            ),
            _react2.default.createElement(
              'span',
              { className: 'was-price-csp-text' },
              this.props.priceBreaks[selectedPriceBreakIndex].wasPriceExVat
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'current-price' },
            _react2.default.createElement(
              'div',
              { className: ' ' + (willPricesOverlap ? 'product-price-newline' : 'product-price') },
              this.props.isCustomerSpecificPricing && _react2.default.createElement(
                'span',
                { className: 'you-pay' },
                this.props.labels.youPayLabel
              ),
              this.props.productPrice.currencySymDisplayFirst && _react2.default.createElement(
                'span',
                {
                  className: 'priceCurrency ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '')
                },
                this.props.productPrice.currencySymbol
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'price ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : ''),
                  content: this.props.productPrice.currencyCode
                },
                this.props.priceBreaks[selectedPriceBreakIndex].priceExVatWithoutCurrencySymbol.toString()
              ),
              !this.props.productPrice.currencySymDisplayFirst && _react2.default.createElement(
                'span',
                {
                  className: 'priceCurrency ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '')
                },
                this.props.productPrice.currencySymbol
              ),
              _react2.default.createElement(
                'div',
                { className: 'vat' },
                this.props.labels.exVatLabel
              )
            ),
            !this.props.priceBreaks[selectedPriceBreakIndex].incVatAndExVatPriceSameFlag && _react2.default.createElement(
              'div',
              { className: ' ' + (willPricesOverlap ? 'product-price-vat-newline' : 'product-price-vat') },
              this.props.productPrice.currencySymDisplayFirst && _react2.default.createElement(
                'span',
                { className: 'priceCurrency txt-vat' },
                this.props.productPrice.currencySymbol
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'price txt-vat',
                  content: this.props.productPrice.currencyCode
                },
                this.props.priceBreaks[selectedPriceBreakIndex].priceIncVatWithoutCurrencySymbol.toString()
              ),
              !this.props.productPrice.currencySymDisplayFirst && _react2.default.createElement(
                'span',
                { className: 'priceCurrency txt-vat' },
                this.props.productPrice.currencySymbol
              ),
              _react2.default.createElement(
                'div',
                { className: 'vat txt-vat' },
                this.props.labels.vatLabel
              )
            )
          )
        ),
        this.props.energyEfficiencyRating && this.props.energyEfficiencyRating.trim() !== '' && _react2.default.createElement(
          'div',
          { className: 'energy-rating other-contents' },
          _react2.default.createElement(_EnergyLabel2.default, {
            src: this.props.energyEfficiencyRating,
            alt: this.props.energyEfficiencyRatingText,
            labelImageLink: this.props.energyEfficiencyImage,
            title: this.props.labels.energyLabelsTitle,
            closeText: this.props.labels.energyLabelsCloseButton
          }),
          _react2.default.createElement(
            'a',
            { href: this.props.energyProductInfoSheetLink, target: '_blank', rel: 'noopener noreferrer', id: 'energy-label-product-information-link', className: 'product-page-energy-label' },
            _react2.default.createElement(
              'u',
              null,
              this.props.labels.energyLabelsProductInformationSheet
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'price-table', id: 'break-prices-list' },
          _react2.default.createElement(
            'div',
            { id: 'column-row', className: 'table-row' },
            _react2.default.createElement(
              'div',
              { className: 'breakRangeWithoutUnit col-xs-' + this.props.colSize },
              this.props.labels.rangeHeaderLabel
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'unitPrice col-xs-' + this.props.colSize + ' ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '')
              },
              this.props.labels.priceHeaderLabel
            ),
            this.props.showIndicativePrices && _react2.default.createElement(
              'div',
              {
                className: 'indicativePrice col-xs-' + this.props.colSize + ' ' + (this.props.isCustomerSpecificPricing ? 'customer-specific-price' : '')
              },
              this.props.labels.indicativePriceHeaderLabel
            )
          ),
          this.props.priceBreaks.map(function (priceBreak, index) {
            return _this2.priceBreakRender(priceBreak, index, selectedPriceBreakIndex);
          }),
          this.props.showIndicativePrices && _react2.default.createElement(
            'div',
            { className: 'priceIndicative' },
            this.props.labels.indicativePriceMessage
          )
        )
      );
    }
  }]);

  return PriceBreak;
}(_react2.default.Component);

exports.default = PriceBreak;

PriceBreak.propTypes = {
  colSize: _propTypes2.default.number.isRequired,
  energyEfficiencyRating: _propTypes2.default.string.isRequired,
  energyEfficiencyRatingText: _propTypes2.default.string.isRequired,
  energyEfficiencyImage: _propTypes2.default.string.isRequired,
  labels: _propTypes2.default.shape({
    rangeHeaderLabel: _propTypes2.default.string,
    priceHeaderLabel: _propTypes2.default.string,
    indicativePriceHeaderLabel: _propTypes2.default.string,
    indicativePriceMessage: _propTypes2.default.string,
    linePriceHeaderLabel: _propTypes2.default.string,
    wasPriceLabel: _propTypes2.default.string,
    exVatLabel: _propTypes2.default.string,
    vatLabel: _propTypes2.default.string,
    youPayLabel: _propTypes2.default.string,
    energyLabelsProductInformationSheet: _propTypes2.default.string,
    energyLabelsTitle: _propTypes2.default.string,
    energyLabelsCloseButton: _propTypes2.default.string
  }),
  showIndicativePrices: _propTypes2.default.bool.isRequired,
  priceBreaks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    priceExVatWithoutCurrencySymbol: _propTypes2.default.string,
    priceIncVatWithoutCurrencySymbol: _propTypes2.default.string,
    priceBreakRange: _propTypes2.default.string,
    priceExVat: _propTypes2.default.string,
    indicativePriceExVat: _propTypes2.default.string,
    incVatAndExVatPriceSameFlag: _propTypes2.default.bool,
    wasPriceExVat: _propTypes2.default.string,
    euEnergyRatingPBJ: _propTypes2.default.string
  })),
  quantity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  packSize: _propTypes2.default.number,
  productPrice: _propTypes2.default.shape({
    currencySymDisplayFirst: _propTypes2.default.bool,
    currencyCode: _propTypes2.default.string,
    currencySymbol: _propTypes2.default.string,
    wasPrice: _propTypes2.default.string,
    wasPriceExVat: _propTypes2.default.string
  }),
  isCustomerSpecificPricing: _propTypes2.default.bool,
  energyProductInfoSheetLink: _propTypes2.default.string
};

PriceBreak.defaultProps = {
  labels: {},
  priceBreaks: [],
  quantity: 0,
  packSize: 1,
  productPrice: {
    currencySymDisplayFirst: true,
    currencyCode: 'GBP',
    currencySymbol: '£',
    wasPrice: undefined,
    wasPriceExVat: undefined
  },
  isCustomerSpecificPricing: false,
  energyProductInfoSheetLink: '/'
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsCssTransitionGroup = __webpack_require__(21);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Modal = __webpack_require__(31);

var _Modal2 = _interopRequireDefault(_Modal);

var _EnergyLabelModal = __webpack_require__(194);

var _EnergyLabelModal2 = _interopRequireDefault(_EnergyLabelModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// note title should be SHAPE energyLabelsTitle
// close btn energyLabelsCloseButton
var EnergyLabel = function (_Component) {
  _inherits(EnergyLabel, _Component);

  function EnergyLabel(props) {
    _classCallCheck(this, EnergyLabel);

    var _this = _possibleConstructorReturn(this, (EnergyLabel.__proto__ || Object.getPrototypeOf(EnergyLabel)).call(this, props));

    _this.state = {
      showModal: false,
      labelImageLink: props.labelImageLink,
      src: props.src,
      alt: props.alt,
      title: props.title,
      closeText: props.closeText
    };
    _this.initiateModal = _this.initiateModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(EnergyLabel, [{
    key: 'initiateModal',
    value: function initiateModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'a',
            { role: 'button', tabIndex: -1, onClick: this.handleClick },
            _react2.default.createElement('img', { src: this.state.src, alt: this.state.alt })
          )
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'fade',
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 300
          },
          this.state.showModal && _react2.default.createElement(
            _Modal2.default,
            {
              open: this.state.showModal,
              onClose: this.closeModal,
              title: this.state.title
            },
            _react2.default.createElement(_EnergyLabelModal2.default, {
              energyLabelImage: this.state.labelImageLink,
              closeModal: this.closeModal,
              closeText: this.state.closeText
            })
          )
        )
      );
    }
  }]);

  return EnergyLabel;
}(_react.Component);

exports.default = EnergyLabel;


EnergyLabel.propTypes = {
  src: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  labelImageLink: _propTypes2.default.string,
  title: _propTypes2.default.string,
  closeText: _propTypes2.default.string
};

EnergyLabel.defaultProps = {
  src: '',
  alt: '',
  labelImageLink: '',
  title: '',
  closeText: ''
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(184);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(188);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(185);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(186);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(189);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(191);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(192);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(193);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(30);

var _PropTypes = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(190);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(91);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(91);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnergyLabelModal = function EnergyLabelModal(props) {
  return _react2.default.createElement(
    'div',
    { className: 'energylabel-container' },
    _react2.default.createElement('img', { src: props.energyLabelImage, alt: 'energy label' }),
    _react2.default.createElement(
      'div',
      { className: 'modal-footer' },
      _react2.default.createElement(
        'button',
        {
          className: 'btn btn-default',
          onClick: props.closeModal
        },
        props.closeText
      )
    )
  );
};

EnergyLabelModal.propTypes = {
  energyLabelImage: _propTypes2.default.string,
  closeModal: _propTypes2.default.func,
  closeText: _propTypes2.default.string
};

EnergyLabelModal.defaultProps = {
  energyLabelImage: '',
  closeModal: null,
  closeText: 'close'
};

exports.default = EnergyLabelModal;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(57);

var _services = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddToBasketButton = function (_React$Component) {
  _inherits(AddToBasketButton, _React$Component);

  function AddToBasketButton(props) {
    _classCallCheck(this, AddToBasketButton);

    var _this = _possibleConstructorReturn(this, (AddToBasketButton.__proto__ || Object.getPrototypeOf(AddToBasketButton)).call(this, props));

    _this.state = {
      isProcessing: false
    };
    return _this;
  }

  _createClass(AddToBasketButton, [{
    key: 'addToBasket',
    value: function addToBasket(stockNumber, quantity) {
      var _this2 = this;

      if (quantity % this.props.packSize !== 0 || quantity === 0) {
        if (this.props.onPackSizeError !== undefined) {
          this.props.onPackSizeError();
        }
        return;
      }

      this.setState({
        isProcessing: true
      });
      (0, _services.AddToBasket)(stockNumber, quantity).then(function () {
        _this2.setState({
          isProcessing: false
        });
        (0, _services.RunningTotal)(); // returns a promise but we don't need to do anything once it resolves
        (0, _services.PublishAddToCartEvent)(stockNumber, quantity, 'Product_New');
        if (_this2.props.onAddedToBasket !== undefined) {
          _this2.props.onAddedToBasket();
        }
      }, function () {
        // At the moment the error will be swallowed but a error handling strategy is being considered
        _this2.setState({
          isProcessing: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isProcessing ? _react2.default.createElement(_components.Button, {
          customClass: 'btn-add-to-basket',
          primary: true,
          large: this.props.isLarge,
          onClick: function onClick() {
            return _this3.addToBasket(_this3.props.stockNumber, _this3.props.quantity);
          },
          label: this.props.label,
          disabled: this.props.disabled
        }) : _react2.default.createElement('span', { className: 'icon icon-rs_39-loading ajax-loader add-to-basket-loader' })
      );
    }
  }]);

  return AddToBasketButton;
}(_react2.default.Component);

exports.default = AddToBasketButton;

AddToBasketButton.propTypes = {
  stockNumber: _propTypes2.default.string,
  quantity: _propTypes2.default.number,
  label: _propTypes2.default.string,
  onAddedToBasket: _propTypes2.default.func,
  isLarge: _propTypes2.default.bool,
  packSize: _propTypes2.default.number,
  onPackSizeError: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};

AddToBasketButton.defaultProps = {
  stockNumber: '111-111',
  quantity: 1,
  label: 'click me',
  onAddedToBasket: undefined,
  isLarge: true,
  packSize: 1,
  onPackSizeError: undefined,
  disabled: false
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  var classes = (0, _helpers.formatClass)('btn ' + (props.primary ? 'btn-primary-red ' : '') + '\n    ' + (props.secondary ? 'btn-secondary-blue ' : '') + '\n    ' + (!props.primary && !props.secondary ? 'btn-default ' : '') + '\n    ' + (props.large ? 'btn-large ' : '') + '\n    ' + props.customClass);

  return _react2.default.createElement(
    'button',
    { type: 'button', className: classes, onClick: function onClick() {
        return props.onClick();
      }, disabled: props.disabled },
    props.label
  );
};

Button.propTypes = {
  label: _propTypes2.default.string,
  primary: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  large: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  customClass: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};

Button.defaultProps = {
  label: 'Click me',
  primary: false,
  secondary: false,
  large: false,
  onClick: function onClick() {
    return undefined;
  },
  customClass: '',
  disabled: false
};

exports.default = Button;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Formatters = __webpack_require__(198);

Object.defineProperty(exports, 'formatClass', {
  enumerable: true,
  get: function get() {
    return _Formatters.formatClass;
  }
});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *  Formats and removes whitespace and line breaks from literals
 * @return string without whitespace and line breaks
 */
var formatClass = exports.formatClass = function formatClass(literal) {
  return literal.replace(/\s\s+/g, ' ');
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetCustomerSpecificPriceBreaks = GetCustomerSpecificPriceBreaks;
exports.CheckProductSensitivity = CheckProductSensitivity;

var _api = __webpack_require__(22);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAndSetWasPrice(originalPriceBreaks, cspPriceBreaks) {
  originalPriceBreaks = originalPriceBreaks.reduce(function (result, pricebreak) {
    result[pricebreak.priceBreakLowerBound + '-' + pricebreak.priceBreakUpperBound] = pricebreak.priceExVat;
    return result;
  }, {});

  cspPriceBreaks.forEach(function (itemCSP) {
    var originalPrice = originalPriceBreaks[itemCSP.priceBreakLowerBound + '-' + itemCSP.priceBreakUpperBound];
    if (originalPrice) {
      itemCSP.wasPriceExVat = originalPrice;
    }
  });
  return cspPriceBreaks;
}

function GetCustomerSpecificPriceBreaks(productId, originalPriceBreaks) {
  var getCustomerSpecificPriceBreaksUrl = '/web/services/product/' + productId + '/prices/v1';

  return _api2.default.get(getCustomerSpecificPriceBreaksUrl).then(function (json) {
    return json && json.length > 0 ? getAndSetWasPrice(originalPriceBreaks, json) : undefined;
  }).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to GetCustomerSpecificPriceBreaks with ' + getCustomerSpecificPriceBreaksUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

function CheckProductSensitivity(productId, rsStockNumber) {
  var checkProductSensitivityUrl = '/web/services/productdetails/productsensitivity/' + productId + '/' + rsStockNumber;

  return _api2.default.get(checkProductSensitivityUrl).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to CheckProductSensitivity with ' + checkProductSensitivityUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToBasket = AddToBasket;

var _api = __webpack_require__(22);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddToBasket(productId, quantity) {
  var addToBasketUrl = '/web/services/shoppingBasket/lineItems/' + productId + '/' + quantity;

  return _api2.default.put(addToBasketUrl, null).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to AddToBasketUrl with ' + addToBasketUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RunningTotal = RunningTotal;

var _promisePolyfill = __webpack_require__(29);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RunningTotal() {
  var promise = new _promisePolyfill2.default(function (resolve, reject) {
    try {
      RS.Modules.UserStatus.runningTotal(); // eslint-disable-line no-undef
      resolve(true);
    } catch (e) {
      reject(e);
    }
  });
  return promise;
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublishAddToCartEvent = PublishAddToCartEvent;

var _promisePolyfill = __webpack_require__(29);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PublishAddToCartEvent(stockNumber, quantity, pageName) {
  var promise = new _promisePolyfill2.default(function (resolve, reject) {
    try {
      RS.Modules.Analytics.publishAddToCartEvent(stockNumber, quantity, pageName); // eslint-disable-line no-undef
      resolve(true);
    } catch (e) {
      reject(e);
    }
  });
  return promise;
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckStock = CheckStock;

var _api = __webpack_require__(22);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckStock(productNumber, productId, quantity) {
  var checkStockUrl = '/web/services/product/getstock/' + productNumber + '/' + productId + '/' + quantity;

  return _api2.default.get(checkStockUrl).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to checkStockUrl with ' + checkStockUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveToNewPartsList = SaveToNewPartsList;
exports.SaveToExistingPartsList = SaveToExistingPartsList;
exports.GetPartsList = GetPartsList;

var _api = __webpack_require__(22);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SaveToNewPartsList(partsListName, articleId, quantity) {
  var saveToPartsListUrl = '/web/services/product/partslist/' + partsListName + '/' + articleId + '/' + quantity;

  return _api2.default.put(saveToPartsListUrl, null).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to SaveToPartsListUrl with ' + saveToPartsListUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

function SaveToExistingPartsList(partsListName, articleId, quantity) {
  var saveToPartsListUrl = '/web/services/product/partslist/' + partsListName + '/' + articleId + '/' + quantity;

  return _api2.default.post(saveToPartsListUrl, null).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to SaveToPartsListUrl with ' + saveToPartsListUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

function GetPartsList() {
  var getPartsListUrl = '/web/services/product/partslist/';

  return _api2.default.get(getPartsListUrl).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to GetPartsListUrl with ' + getPartsListUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlEntitiesDecode = HtmlEntitiesDecode;
function HtmlEntitiesDecode(encodedString) {
  var entities = {
    amp: '&',
    apos: "'",
    '#x27': "'",
    '#x2F': '/',
    '#39': "'",
    '#34': '"',
    '#47': '/',
    lt: '<',
    gt: '>',
    nbsp: ' ',
    quot: '"'
  };
  return encodedString.replace(/&([^;]+);/gm, function (match, entity) {
    return entities[entity] || match;
  });
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetProductDataLibrary = GetProductDataLibrary;

var _api = __webpack_require__(22);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GetProductDataLibrary(productDataLibraryUrl) {
  return _api2.default.get(productDataLibraryUrl).catch(function (exception) {
    var error = exception;
    error.statusText = 'Call to GetProductDataLibrary with ' + productDataLibraryUrl + ' failed. ' + exception.statusText;
    return Promise.reject(error);
  });
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormatDate = FormatDate;
function FormatDate(date, formatString) {
  // Local variable declaration
  var currentChar = '';
  var nextChar = '';
  var pattern = '';
  // Looping over the format string to search for pattern and replace the pattern with appropriate value.
  for (var i = 0; i < formatString.length; i += 1) {
    currentChar = formatString.charAt(i);
    nextChar = formatString.charAt(i + 1);
    pattern += currentChar;
    if (currentChar !== nextChar) {
      formatString = replacePattern(formatString, pattern, date);
      pattern = '';
    }
  }
  return formatString;
}

function replacePattern(formatString, pattern, date) {
  // Array for short month names.
  var shortMonthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  // Array for long month names.
  var longMonthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

  switch (pattern) {
    case 'd':
      formatString = formatString.replace(pattern, date.getDate());
      break;
    case 'dd':
      {
        var dateStr = date.getDate();
        dateStr = '' + dateStr;
        dateStr = dateStr.length < 2 ? padToLeft('0', 1, dateStr) : dateStr;
        formatString = formatString.replace(pattern, dateStr);
        break;
      }
    case 'M':
      formatString = formatString.replace(pattern, date.getMonth() + 1);
      break;
    case 'MM':
      {
        var monthStr = date.getMonth() + 1;
        monthStr = '' + monthStr;
        monthStr = monthStr.length < 2 ? padToLeft('0', 1, monthStr) : monthStr;
        formatString = formatString.replace(pattern, monthStr);
        break;
      }
    case 'MMM':
      formatString = formatString.replace(pattern, shortMonthNames[date.getMonth()]);
      break;
    case 'MMMM':
      formatString = formatString.replace(pattern, longMonthNames[date.getMonth()]);
      break;
    case 'yy':
      formatString = formatString.replace(pattern, ('' + date.getFullYear()).slice(-2));
      break;
    case 'yyyy':
      formatString = formatString.replace(pattern, date.getFullYear());
      break;
    default:
  }
  return formatString;
}

function padToLeft(padChar, padCount, targetString) {
  var padStr = '';
  for (var i = 0; i < padCount; i += 1) {
    padStr += padChar;
  }
  return padStr + targetString;
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewBasketButton = function (_React$Component) {
  _inherits(ViewBasketButton, _React$Component);

  function ViewBasketButton() {
    _classCallCheck(this, ViewBasketButton);

    return _possibleConstructorReturn(this, (ViewBasketButton.__proto__ || Object.getPrototypeOf(ViewBasketButton)).apply(this, arguments));
  }

  _createClass(ViewBasketButton, [{
    key: 'viewBasket',
    value: function viewBasket() {
      ViewBasketButton.getWindow().location.assign(this.props.redirectUrl);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_components.Button, {
        customClass: 'nav-view-cart ' + this.props.className,
        secondary: true,
        large: true,
        onClick: function onClick() {
          return _this2.viewBasket();
        },
        label: this.props.label
      });
    }
  }], [{
    key: 'getWindow',

    /**
     * for mock purpose
     */
    value: function getWindow() {
      return window;
    }
  }]);

  return ViewBasketButton;
}(_react2.default.Component);

exports.default = ViewBasketButton;

ViewBasketButton.propTypes = {
  label: _propTypes2.default.string,
  redirectUrl: _propTypes2.default.string,
  className: _propTypes2.default.string
};

ViewBasketButton.defaultProps = {
  label: 'click me',
  redirectUrl: '',
  className: ''
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckStockModal = function (_React$Component) {
  _inherits(CheckStockModal, _React$Component);

  function CheckStockModal(props) {
    _classCallCheck(this, CheckStockModal);

    var _this = _possibleConstructorReturn(this, (CheckStockModal.__proto__ || Object.getPrototypeOf(CheckStockModal)).call(this, props));

    _this.state = {
      quantity: _this.props.initialQuantity,
      articleAvailability: null,
      hasBeenAddedToBasket: false
    };

    _this.iconClasses = {
      Green: 'icon-rs_57-tick',
      Amber: 'icon-rs_37-info',
      Red: 'icon-rs_61-warning'
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.addedToBasket = _this.addedToBasket.bind(_this);
    return _this;
  }

  _createClass(CheckStockModal, [{
    key: 'handleChange',
    value: function handleChange(quantity) {
      this.setState({
        quantity: quantity
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(articleAvailability) {
      this.setState({
        articleAvailability: articleAvailability,
        quantity: Boolean(articleAvailability) === true ? articleAvailability.roundedQuantity : 0,
        hasBeenAddedToBasket: false
      });
    }
  }, {
    key: 'addedToBasket',
    value: function addedToBasket() {
      this.setState({
        hasBeenAddedToBasket: true
      });
      if (this.props.onAddToBasket) {
        this.props.onAddToBasket(this.state.quantity);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var availability = this.state.articleAvailability;
      return _react2.default.createElement(
        'div',
        { className: 'stocklevel-container' },
        _react2.default.createElement(
          'div',
          { className: 'description' },
          this.props.labels.checkStockHelpText
        ),
        _react2.default.createElement(
          'div',
          { className: 'stock-number' },
          this.props.labels.stockNumber,
          _react2.default.createElement(
            'label',
            { htmlFor: 'check-quantity' },
            this.props.stockNumber
          )
        ),
        availability && Object.keys(availability).length > 0 && availability.displayRoundedMessage && _react2.default.createElement(
          'div',
          { className: 'rounded-message' },
          availability.roundedMessage
        ),
        _react2.default.createElement(
          'div',
          { className: 'interactive-container' },
          _react2.default.createElement(
            'span',
            null,
            this.props.labels.lookingForText
          ),
          '\xA0',
          _react2.default.createElement(_.QuantityInput, {
            className: 'check-quantity',
            value: this.state.quantity,
            maximumQuantity: this.props.maximumQuantity,
            onChangeHandler: this.handleChange
          }),
          '\xA0',
          _react2.default.createElement(_.CheckStockButton, {
            label: this.props.labels.checkStock,
            productNumber: this.props.productNumber,
            productId: this.props.productId,
            quantity: this.state.quantity,
            onCheckStock: this.handleClick
          })
        ),
        availability && Object.keys(availability).length > 0 && _react2.default.createElement(
          'div',
          { className: 'bottom-content' },
          !this.state.hasBeenAddedToBasket && _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'div',
              { className: 'stock-content content-row' },
              _react2.default.createElement(
                'div',
                { className: 'atp-message-container' },
                availability.promiseBannerMessage && _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'dtp-message-container dtp-stock-warning' },
                    _react2.default.createElement(
                      'div',
                      { className: 'dtpFormattedMessage' },
                      availability.promiseBannerMessage
                    )
                  ),
                  _react2.default.createElement('br', null)
                ),
                availability.promiseMessage && _react2.default.createElement(
                  'div',
                  { className: 'dtp-message-container' },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: availability.promiseStatusCode === 'ERROR' || availability.promiseStatusCode === null ? 'dtp-results-error' : 'dtp-results' },
                      _react2.default.createElement(
                        'span',
                        { className: 'dtp-stock-badge dtp-stock-badge-' + availability.promiseStatusCode },
                        _react2.default.createElement('img', { src: availability.promiseBadgeIcon, alt: availability.promiseStatusCode, className: 'dtp-stock-level-icon' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'dtpFormattedMessage' },
                          availability.promiseMessage.map(function (part) {
                            return _react2.default.createElement(
                              'span',
                              { className: part.name },
                              part.value
                            );
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'ul',
                        { className: 'dtp-stock-promise dtp-stockcheck-schedules' },
                        availability.promiseSchedules.map(function (scheduleMessageParts) {
                          return _react2.default.createElement(
                            'li',
                            null,
                            scheduleMessageParts.map(function (part) {
                              return _react2.default.createElement(
                                'span',
                                { className: part.name },
                                part.value
                              );
                            })
                          );
                        })
                      )
                    )
                  )
                ),
                !availability.promiseMessage && availability.availabilityMessageTO.availabilityHeaderMessage && _react2.default.createElement(
                  'div',
                  { className: 'atp-message atp-partial-stock Green' },
                  _react2.default.createElement(
                    'div',
                    { className: 'atp-header' },
                    _react2.default.createElement('i', { className: 'icon icon-rs_57-tick', 'aria-hidden': 'true' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'atp-text' },
                      availability.availabilityMessageTO.headerQuantity,
                      ' ',
                      availability.availabilityMessageTO.availabilityHeaderMessage
                    )
                  )
                ),
                !availability.promiseMessage && availability.availabilityMessageTO.partialStockStatusMessageTO.map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: item.availabilityIndicator,
                      className: ' ' + (availability.availabilityMessageTO.availabilityHeaderMessage !== null ? 'sub' : 'atp-message') + ' ' + item.atpIcon + ' '
                    },
                    _react2.default.createElement('i', {
                      className: 'icon ' + (availability.availabilityMessageTO.availabilityHeaderMessage === null ? _this2.iconClasses[item.atpIcon] : null) + ' ',
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'span',
                      { className: 'atp-text' },
                      item.quantity,
                      ' ',
                      item.availabilityMessage
                    )
                  );
                }),
                !availability.promiseMessage && availability.availabilityMessageTO.nonPartialStockStatusMessageTO.map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { key: item.availabilityIndicator, className: 'atp-message ' + item.atpIcon },
                    _react2.default.createElement('i', {
                      className: 'icon ' + _this2.iconClasses[item.atpIcon],
                      'aria-hidden': 'true'
                    }),
                    _react2.default.createElement(
                      'span',
                      { className: 'atp-text' },
                      item.quantity,
                      ' ',
                      item.availabilityMessage
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'btn-container' },
                _react2.default.createElement(_.AddToBasketButton, {
                  stockNumber: this.props.stockNumber,
                  quantity: this.state.quantity,
                  label: 'Add ' + this.state.articleAvailability.roundedQuantity,
                  isLarge: false,
                  onAddedToBasket: this.addedToBasket,
                  disabled: availability.promiseNoAddToCart
                })
              )
            )
          ),
          this.state.hasBeenAddedToBasket && _react2.default.createElement(
            'div',
            { className: 'cart-result content-row' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { className: 'btn btn-default btn-shopping', onClick: this.props.closeModal },
                this.props.labels.continueShopping
              ),
              _react2.default.createElement(_.ViewBasketButton, { label: this.props.labels.checkout, redirectUrl: this.props.basketUrl, className: 'float-right' }),
              _react2.default.createElement(
                'div',
                { className: 'cart-added stock-check-cart-added' },
                _react2.default.createElement('i', { className: 'icon icon-rs_57-tick', 'aria-hidden': 'true' }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.props.labels.added
                )
              )
            ),
            _react2.default.createElement('div', { className: 'clr' })
          )
        )
      );
    }
  }]);

  return CheckStockModal;
}(_react2.default.Component);

exports.default = CheckStockModal;


CheckStockModal.propTypes = {
  stockNumber: _propTypes2.default.string,
  productNumber: _propTypes2.default.string,
  productId: _propTypes2.default.string,
  initialQuantity: _propTypes2.default.number.isRequired,
  labels: _propTypes2.default.shape({
    checkStockHelpText: _propTypes2.default.string,
    stockNumber: _propTypes2.default.string,
    lookingForText: _propTypes2.default.string,
    checkStock: _propTypes2.default.string,
    addToCart: _propTypes2.default.string,
    continueShopping: _propTypes2.default.string,
    checkout: _propTypes2.default.string,
    added: _propTypes2.default.string
  }),
  maximumQuantity: _propTypes2.default.number.isRequired,
  closeModal: _propTypes2.default.func,
  basketUrl: _propTypes2.default.string,
  onAddToBasket: _propTypes2.default.func
};

CheckStockModal.defaultProps = {
  stockNumber: '',
  productNumber: '',
  productId: '',
  labels: {},
  closeModal: null,
  basketUrl: '',
  onAddToBasket: null
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _QuantityInput = __webpack_require__(94);

var _QuantityInput2 = _interopRequireDefault(_QuantityInput);

var _services = __webpack_require__(13);

var _PartsListAdded = __webpack_require__(95);

var _PartsListAdded2 = _interopRequireDefault(_PartsListAdded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var maxPartsNameLength = 30;

var PartsListModal = function (_React$Component) {
  _inherits(PartsListModal, _React$Component);

  _createClass(PartsListModal, null, [{
    key: 'preventDefaultAction',
    value: function preventDefaultAction(event) {
      event.preventDefault();
    }
  }]);

  function PartsListModal(props) {
    _classCallCheck(this, PartsListModal);

    var _this = _possibleConstructorReturn(this, (PartsListModal.__proto__ || Object.getPrototypeOf(PartsListModal)).call(this, props));

    _this.state = {
      partsList: [],
      hasList: false,
      quantity: _this.props.initialQuantity,
      createNewPartsList: true,
      isQuantityValid: true,
      partsListName: '',
      isPartsListNameValid: false,
      isPartsListSelectValid: false,
      addedQuantity: null,
      successMessage: null,
      errorMessage: null,
      partsListDetailsUrl: null
    };

    _this.handleExistingListChange = _this.handleExistingListChange.bind(_this);
    _this.handleNewListChange = _this.handleNewListChange.bind(_this);
    _this.handleQuantityChange = _this.handleQuantityChange.bind(_this);
    _this.handlePartsListNameChange = _this.handlePartsListNameChange.bind(_this);
    _this.handlePartsListSelectChange = _this.handlePartsListSelectChange.bind(_this);
    _this.handleSave = _this.handleSave.bind(_this);
    return _this;
  }

  _createClass(PartsListModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _services.GetPartsList)().then(function (_ref) {
        var partsLists = _ref.partsLists;

        _this2.setState({
          partsList: partsLists,
          hasList: partsLists && partsLists.length > 0,
          createNewPartsList: !(partsLists && partsLists.length > 0)
        });
      });
    }
  }, {
    key: 'setSaveSuccessful',
    value: function setSaveSuccessful(partsListResponse) {
      this.setState({
        addedQuantity: partsListResponse.quantity,
        successMessage: partsListResponse.successMessage,
        errorMessage: partsListResponse.errorMessage,
        partsListDetailsUrl: this.props.contextPath + partsListResponse.partsListDetailsUrl
      });
    }
  }, {
    key: 'handleExistingListChange',
    value: function handleExistingListChange() {
      this.setState({
        createNewPartsList: false,
        isPartsListNameValid: false,
        partsListName: ''
      });
    }
  }, {
    key: 'handleNewListChange',
    value: function handleNewListChange() {
      this.setState({
        createNewPartsList: true,
        isPartsListSelectValid: false,
        partsListName: ''
      });
    }
  }, {
    key: 'handleQuantityChange',
    value: function handleQuantityChange(quantity) {
      this.setState({
        quantity: quantity,
        isQuantityValid: quantity !== ''
      });
    }
  }, {
    key: 'handlePartsListNameChange',
    value: function handlePartsListNameChange(e) {
      if (e.target.value.length > maxPartsNameLength) return;
      this.setState({
        partsListName: e.target.value,
        isPartsListNameValid: e.target.value !== ''
      });
    }
  }, {
    key: 'handlePartsListSelectChange',
    value: function handlePartsListSelectChange(e) {
      this.setState({
        partsListName: e.target.value,
        isPartsListSelectValid: e.target.value !== ''
      });
    }
  }, {
    key: 'isSaveButtonEnabled',
    value: function isSaveButtonEnabled() {
      return this.state.isQuantityValid && this.state.isPartsListSelectValid && !this.state.createNewPartsList || this.state.isQuantityValid && this.state.isPartsListNameValid && this.state.createNewPartsList;
    }
  }, {
    key: 'handleSave',
    value: function handleSave() {
      var _this3 = this;

      if (this.state.createNewPartsList) {
        (0, _services.SaveToNewPartsList)(this.state.partsListName, this.props.productNumber, this.state.quantity).then(function (partsListResponse) {
          _this3.setSaveSuccessful(partsListResponse);
        });
      } else {
        (0, _services.SaveToExistingPartsList)(this.state.partsListName, this.props.productNumber, this.state.quantity).then(function (partsListResponse) {
          _this3.setSaveSuccessful(partsListResponse);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return !this.state.successMessage ? _react2.default.createElement(
        'div',
        { className: 'parts-list', id: 'add-to-parts-list' },
        _react2.default.createElement(
          'div',
          { className: 'parts-title' },
          this.props.labels.partsListTitle
        ),
        _react2.default.createElement(
          'div',
          { className: 'product table' },
          _react2.default.createElement(_QuantityInput2.default, {
            className: 'product-quantity table-cell',
            value: this.state.quantity,
            maximumQuantity: this.props.maximumQuantity,
            onChangeHandler: this.handleQuantityChange
          }),
          _react2.default.createElement(
            'div',
            { className: 'product-details table-cell' },
            _react2.default.createElement(
              'div',
              null,
              this.props.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'rsStockNumberDiv' },
              _react2.default.createElement(
                'span',
                null,
                this.props.stockNumber
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'mpnNumberDiv' },
              _react2.default.createElement(
                'span',
                null,
                this.props.manufacturerPartNumber
              )
            )
          )
        ),
        _react2.default.createElement('hr', null),
        this.state.hasList && _react2.default.createElement(
          'div',
          { className: 'selector' },
          _react2.default.createElement(
            'label',
            { htmlFor: 'existing-list' },
            _react2.default.createElement('input', {
              className: 'option-rd',
              type: 'radio',
              name: 'existing-new',
              id: 'existing-list',
              onChange: this.handleExistingListChange,
              defaultChecked: this.state.hasList
            }),
            _react2.default.createElement(
              'span',
              { className: 'option-lb' },
              this.props.labels.addToExistingPartsList
            )
          ),
          _react2.default.createElement(
            'label',
            { htmlFor: 'new-list' },
            _react2.default.createElement('input', {
              className: 'option-rd',
              type: 'radio',
              name: 'existing-new',
              onChange: this.handleNewListChange,
              id: 'new-list',
              defaultChecked: !this.state.hasList
            }),
            _react2.default.createElement(
              'span',
              { className: 'option-lb' },
              this.props.labels.saveToNewPartsList
            )
          )
        ),
        !this.state.createNewPartsList ? _react2.default.createElement(
          'div',
          { className: 'existing-new existing-list', id: 'existing-list-form' },
          _react2.default.createElement(
            'div',
            { className: 'textTitle' },
            this.props.labels.saveToExistingPartsListTitle
          ),
          _react2.default.createElement(
            'select',
            { className: 'partsListName', name: 'partsListName', onChange: this.handlePartsListSelectChange },
            _react2.default.createElement(
              'option',
              { defaultValue: '', value: '' },
              this.props.labels.pleaseSelect
            ),
            this.state.partsList.map(function (part) {
              return _react2.default.createElement(
                'option',
                { className: 'parts-list-item', value: part.name, key: part.id },
                part.name
              );
            })
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'existing-new new-list', id: 'new-list-form' },
          _react2.default.createElement(
            'div',
            { className: 'textTitle' },
            this.props.labels.saveToNewPartsListTitle
          ),
          this.state.errorMessage && _react2.default.createElement(
            'div',
            { className: 'error-message hidden', id: 'parts-list-name-error' },
            this.state.errorMessage
          ),
          _react2.default.createElement(
            'div',
            { className: '' },
            this.props.labels.newPartsListName
          ),
          _react2.default.createElement('input', {
            className: 'partsListName',
            name: 'partsListName',
            value: this.state.partsListName,
            onChange: this.handlePartsListNameChange,
            onPaste: function onPaste(event) {
              return PartsListModal.preventDefaultAction(event);
            },
            onDrop: function onDrop(event) {
              return PartsListModal.preventDefaultAction(event);
            }
          })
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(
            'button',
            { className: 'btn btn-default', onClick: this.props.closeModal },
            this.props.labels.cancel
          ),
          '\xA0',
          _react2.default.createElement(
            'button',
            {
              className: 'btn btn-primary btn-save',
              disabled: !this.isSaveButtonEnabled(),
              onClick: this.handleSave
            },
            this.props.labels.saveToPartsList
          )
        )
      ) : _react2.default.createElement(_PartsListAdded2.default, {
        name: this.props.name,
        manufacturerPartNumber: this.props.manufacturerPartNumber,
        stockNumber: this.props.stockNumber,
        labels: this.props.labels,
        successMessage: this.state.successMessage,
        adddedQuantity: this.state.addedQuantity,
        closeModal: this.props.closeModal,
        partsListDetailsUrl: this.state.partsListDetailsUrl
      });
    }
  }]);

  return PartsListModal;
}(_react2.default.Component);

exports.default = PartsListModal;


PartsListModal.propTypes = {
  contextPath: _propTypes2.default.string,
  name: _propTypes2.default.string,
  stockNumber: _propTypes2.default.string,
  initialQuantity: _propTypes2.default.number,
  maximumQuantity: _propTypes2.default.number,
  manufacturerPartNumber: _propTypes2.default.string,
  productNumber: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    partsListTitle: _propTypes2.default.string,
    addToExistingPartsList: _propTypes2.default.string,
    saveToNewPartsList: _propTypes2.default.string,
    saveToExistingPartsListTitle: _propTypes2.default.string,
    pleaseSelect: _propTypes2.default.string,
    saveToNewPartsListTitle: _propTypes2.default.string,
    newPartsListName: _propTypes2.default.string,
    cancel: _propTypes2.default.string,
    saveToPartsList: _propTypes2.default.string
  }),
  closeModal: _propTypes2.default.func
};

PartsListModal.defaultProps = {
  contextPath: null,
  name: '',
  stockNumber: '',
  initialQuantity: 0,
  maximumQuantity: 9,
  manufacturerPartNumber: '',
  productNumber: '',
  labels: {},
  closeModal: null
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decodeHtml(html) {
  if (!html) return html;
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

function messageText(term, label, message, className) {
  var labelParts = label.replace(/"/g, '').split('##').filter(function (elem) {
    return elem !== '';
  });
  var indexOfTerm = labelParts.indexOf(term);
  var before = indexOfTerm > 0 ? decodeHtml(labelParts[0]) : null;
  var after = indexOfTerm === 1 ? decodeHtml(labelParts[2]) : decodeHtml(labelParts[1]);

  return _react2.default.createElement(
    'div',
    { className: className },
    before,
    _react2.default.createElement(
      'span',
      { className: term === 'searchTerm' && 'no-results-text' },
      message
    ),
    after
  );
}

var SearchMessage = function SearchMessage(props) {
  return props.messages.noResultsFound && props.messages.showingResultsFor ? _react2.default.createElement(
    'div',
    { className: 'message-header' },
    messageText('searchTerm', props.labels.noResultsFoundLabel, props.messages.noResultsFound, 'message-title'),
    messageText('autoCorrectMsg', props.labels.showingResultsForLabel, props.messages.showingResultsFor, 'message-body')
  ) : null;
};

SearchMessage.propTypes = {
  messages: _propTypes2.default.shape({
    noResultsFound: _propTypes2.default.string,
    showingResultsFor: _propTypes2.default.string
  }),
  labels: _propTypes2.default.shape({
    noResultsFoundLabel: _propTypes2.default.string,
    showingResultsForLabel: _propTypes2.default.string
  })
};

SearchMessage.defaultProps = {
  messages: {},
  labels: {}
};

exports.default = SearchMessage;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(57);

var _services = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckStockButton = function (_React$Component) {
  _inherits(CheckStockButton, _React$Component);

  function CheckStockButton(props) {
    _classCallCheck(this, CheckStockButton);

    var _this = _possibleConstructorReturn(this, (CheckStockButton.__proto__ || Object.getPrototypeOf(CheckStockButton)).call(this, props));

    _this.state = {
      isProcessing: false
    };
    return _this;
  }

  _createClass(CheckStockButton, [{
    key: 'checkStock',
    value: function checkStock(productNumber, productId, quantity) {
      var _this2 = this;

      this.setState({
        isProcessing: true
      });

      (0, _services.CheckStock)(productNumber, productId, quantity).then(function (response) {
        _this2.setState({
          isProcessing: false
        });
        if (_this2.props.onCheckStock !== undefined) {
          _this2.props.onCheckStock(response);
        }
      }, function () {
        // At the moment the error will be swallowed but a error handling strategy is being considered
        _this2.setState({
          isProcessing: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'check-stock-button-container' },
        !this.state.isProcessing ? _react2.default.createElement(_components.Button, {
          customClass: 'btn-check-stock-level',
          primary: true,
          onClick: function onClick() {
            return _this3.checkStock(_this3.props.productNumber, _this3.props.productId, _this3.props.quantity);
          },
          label: this.props.label
        }) : _react2.default.createElement('span', { className: 'icon icon-rs_39-loading ajax-loader' })
      );
    }
  }]);

  return CheckStockButton;
}(_react2.default.Component);

exports.default = CheckStockButton;

CheckStockButton.propTypes = {
  productNumber: _propTypes2.default.string,
  productId: _propTypes2.default.string,
  quantity: _propTypes2.default.number,
  label: _propTypes2.default.string,
  onCheckStock: _propTypes2.default.func
};

CheckStockButton.defaultProps = {
  productNumber: '1111111',
  productId: '22222222',
  quantity: 0,
  label: 'click me',
  onCheckStock: undefined
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkedProduct = function LinkedProduct(props) {
  return _react2.default.createElement(
    'div',
    { className: 'linked-product', key: props.id },
    _react2.default.createElement(
      'a',
      { href: props.contextPath + props.productLinkUrl },
      _react2.default.createElement(
        'span',
        { className: 'linked-product-thumbnail' },
        _react2.default.createElement('img', { className: 'linked-product-thumbnail-image', src: props.imagePath, alt: props.productDescription })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'linked-product-detail' },
      _react2.default.createElement(
        'p',
        { className: 'linked-product-description' },
        _react2.default.createElement(
          'a',
          { href: '' + props.contextPath + props.productLinkUrl },
          props.productDescription
        )
      ),
      _react2.default.createElement(
        'p',
        { className: 'linked-product-price' },
        props.price,
        _react2.default.createElement(
          'span',
          { className: 'linked-product-price-label' },
          props.pricingLabel
        )
      ),
      _react2.default.createElement(
        'p',
        { className: 'linked-product-stock-number' },
        props.labels.rsStockNo,
        _react2.default.createElement(
          'span',
          { className: 'linked-product-stock-number-label' },
          props.stockNumber
        )
      )
    )
  );
};

LinkedProduct.propTypes = {
  stockNumber: _propTypes2.default.string,
  productDescription: _propTypes2.default.string,
  imagePath: _propTypes2.default.string,
  productLinkUrl: _propTypes2.default.string,
  id: _propTypes2.default.number,
  price: _propTypes2.default.string,
  pricingLabel: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    priceEach: _propTypes2.default.string,
    rsStockNo: _propTypes2.default.string,
    viewProductInfo: _propTypes2.default.string,
    compare: _propTypes2.default.string
  }),
  contextPath: _propTypes2.default.string
};

LinkedProduct.defaultProps = {
  stockNumber: null,
  productDescription: null,
  imagePath: null,
  productLinkUrl: null,
  id: null,
  price: '',
  pricingLabel: '',
  labels: {},
  contextPath: ''
};

exports.default = LinkedProduct;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Popup = function Popup(props) {
  return props.open && _react2.default.createElement(
    'div',
    { className: 'popup' },
    _react2.default.createElement(
      'div',
      { className: 'popup-body' },
      _react2.default.createElement(
        'span',
        { className: 'popup-content' },
        props.children
      ),
      _react2.default.createElement(
        'button',
        { type: 'button', onClick: function onClick() {
            return props.onClose();
          }, className: 'close', 'aria-label': 'Close' },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        )
      )
    )
  );
};

Popup.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

Popup.defaultProps = {
  open: false,
  onClose: null,
  children: null
};

exports.default = Popup;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelatedCategory = function RelatedCategory(props) {
  return _react2.default.createElement(
    'a',
    { className: 'related-category-link', href: '' + props.baseUrl + props.url },
    props.categoryName
  );
};

RelatedCategory.propTypes = {
  categoryName: _propTypes2.default.string,
  url: _propTypes2.default.string,
  baseUrl: _propTypes2.default.string
};

RelatedCategory.defaultProps = {
  categoryName: '',
  url: '',
  baseUrl: ''
};

exports.default = RelatedCategory;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalibratedProduct = function CalibratedProduct(props) {
  return _react2.default.createElement(
    'div',
    { className: 'calibrated-product', key: props.id },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'calibrated-product-logo' },
        props.productLogoText
      ),
      _react2.default.createElement(
        'div',
        { className: 'calibrated-product-icon' },
        _react2.default.createElement('i', { className: 'RSLL-icon icon icon-rs_134-brand-calibration' })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'calibrated-product-detail' },
      _react2.default.createElement(
        'p',
        { className: 'calibrated-product-description' },
        _react2.default.createElement(
          'span',
          { className: 'calibrated-product-number-label' },
          props.labels.rsStockNo
        ),
        _react2.default.createElement(
          'span',
          { className: 'calibrated-product-number' },
          props.productId
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'calibrated-product-button-container' },
      _react2.default.createElement(
        'a',
        { className: 'calibrated-product-view-button', href: '/web' + props.productLinkUrl },
        props.labels.view
      )
    )
  );
};

CalibratedProduct.propTypes = {
  id: _propTypes2.default.number,
  productId: _propTypes2.default.number,
  productLogoText: _propTypes2.default.string,
  productLinkUrl: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    rsStockNo: _propTypes2.default.string,
    view: _propTypes2.default.string
  })
};

CalibratedProduct.defaultProps = {
  id: 0,
  productId: 0,
  productLogoText: '',
  productLinkUrl: '',
  labels: {}
};

exports.default = CalibratedProduct;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(49);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCarouselContainer = function ImageCarouselContainer(props) {
  return _react2.default.createElement(_components.ImageCarousel, {
    images: props.images,
    maxCarouselSize: props.maxCarouselSize,
    shared: props.shared,
    video: props.video,
    vfmFlagImages: props.vfmFlagImages
  });
};

ImageCarouselContainer.propTypes = {
  images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string.isRequired,
    largeImageURL: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired
  })).isRequired,
  maxCarouselSize: _propTypes2.default.number.isRequired,
  shared: _propTypes2.default.shape({
    isShared: _propTypes2.default.bool.isRequired,
    sharedMessage: _propTypes2.default.string.isRequired
  }).isRequired,
  video: _propTypes2.default.shape({
    thumbnailURL: _propTypes2.default.string,
    videoURL: _propTypes2.default.string
  }).isRequired,
  vfmFlagImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    imageURL: _propTypes2.default.string.isRequired,
    imageName: _propTypes2.default.string.isRequired,
    hoverText: _propTypes2.default.string.isRequired
  })).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    images: state.ImageCarousel.images,
    maxCarouselSize: state.ImageCarousel.maxCarouselSize,
    shared: state.ImageCarousel.shared,
    video: state.ImageCarousel.video,
    vfmFlagImages: state.ImageCarousel.vfmFlagImages
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImageCarouselContainer);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _universalCookie = __webpack_require__(219);

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _reactAddonsCssTransitionGroup = __webpack_require__(21);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _components = __webpack_require__(7);

var _services = __webpack_require__(13);

var _Modal = __webpack_require__(31);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputSpinnerContainer = function (_React$Component) {
  _inherits(InputSpinnerContainer, _React$Component);

  function InputSpinnerContainer(props) {
    _classCallCheck(this, InputSpinnerContainer);

    var _this = _possibleConstructorReturn(this, (InputSpinnerContainer.__proto__ || Object.getPrototypeOf(InputSpinnerContainer)).call(this, props));

    var rsWebProductModel = window.rs.web.product.model;
    _this.state = {
      contextPath: rsWebProductModel.contextPath,
      productNumber: rsWebProductModel.productNumber,
      stockNumber: rsWebProductModel.stockNumber,
      productId: rsWebProductModel.productId,
      initialQuantity: rsWebProductModel.initialQuantity,
      packSize: rsWebProductModel.packSize,
      maximumQuantity: rsWebProductModel.maximumQuantity,
      colSize: rsWebProductModel.colSize,
      labels: rsWebProductModel.labels,
      showIndicativePrices: rsWebProductModel.showIndicativePrices,
      priceBreaks: rsWebProductModel.priceBreaks,
      quantity: rsWebProductModel.initialQuantity,
      wasPrice: rsWebProductModel.wasPrice,
      productPrice: rsWebProductModel.productPrice,
      isCustomerSpecificPricing: false,
      hasAddedToBasket: false,
      basketUrl: rsWebProductModel.basketUrl,
      showRealTimeQuantityChecker: rsWebProductModel.showRealTimeQuantityChecker,
      saveToPartsListLinkUrl: rsWebProductModel.saveToPartsListLinkUrl,
      name: rsWebProductModel.name,
      manufacturerPartNumber: rsWebProductModel.manufacturerPartNumber,
      energyEfficiencyRating: rsWebProductModel.energyEfficiencyRating,
      energyProductInfoSheet: rsWebProductModel.energyProductInfoSheet,
      energyEfficiencyRatingText: rsWebProductModel.energyEfficiencyRatingText,
      energyEfficiencyImage: rsWebProductModel.energyEfficiencyImage,
      restrictions: {
        restricted: false,
        barred: false,
        hasRestrictions: function hasRestrictions() {
          return this.restricted || this.barred;
        }
      },
      customerDisplayText: '',
      infoText: '',
      showCheckStockModal: false,
      displayPackSizeWarning: false,
      showPartsListModal: rsWebProductModel.partsList.popupPartsList,
      restrictBackOrder: rsWebProductModel.restrictBackOrder,
      promiseCannotBackOrder: rsWebProductModel.promiseCannotBackOrder,
      promiseQuantity: rsWebProductModel.promiseQuantity,
      promiseNoAddToCart: rsWebProductModel.promiseNoAddToCart
    };

    _this.handlePartsListClick = _this.handlePartsListClick.bind(_this);
    _this.closeCheckStockModal = _this.closeCheckStockModal.bind(_this);
    _this.closePartsListModal = _this.closePartsListModal.bind(_this);
    _this.sendAddBeacon = _this.sendAddBeacon.bind(_this);
    _this.modalAddedToBasketFunc = _this.modalAddedToBasketFunc.bind(_this);
    return _this;
  }

  _createClass(InputSpinnerContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var cookies = new _universalCookie2.default();
      var isloggedInCookie = cookies.get('loginStatus');

      var loginStatusListForCustomerSpecificPricing = ['5', '6', '14', '22'];

      var customerSpecificPricing = loginStatusListForCustomerSpecificPricing.indexOf(isloggedInCookie) > -1;

      if (isloggedInCookie && customerSpecificPricing) {
        (0, _services.GetCustomerSpecificPriceBreaks)(this.state.productNumber, this.state.priceBreaks).then(function (json) {
          if (json && json.length > 0) _this2.setState({ priceBreaks: json, isCustomerSpecificPricing: true });
        }, function () {
          // At the moment the error will be swallowed but a error handling strategy is being considered
        });
      }

      if (isloggedInCookie && parseInt(isloggedInCookie, 0) >= 10 && parseInt(isloggedInCookie, 0) <= 22) {
        (0, _services.CheckProductSensitivity)(this.state.productId, this.state.stockNumber).then(function (json) {
          if (json && json.restriction) {
            _this2.setState(function (prevState) {
              return {
                restrictions: _extends({}, prevState.restrictions, { restricted: json.restriction === 'restricted', barred: json.restriction === 'barred'
                }),
                customerDisplayText: json.customerDisplayText,
                infoText: json.infoText
              };
            });
          }
        }, function () {});
      }
    }
  }, {
    key: 'quantityUpdated',
    value: function quantityUpdated(newQuantity) {
      this.setState({
        quantity: newQuantity,
        displayPackSizeWarning: false
      });
    }
  }, {
    key: 'displayPackSizeWarning',
    value: function displayPackSizeWarning() {
      this.setState({
        displayPackSizeWarning: true
      });
    }
  }, {
    key: 'sendAddBeacon',
    value: function sendAddBeacon(itemQuantity) {
      function getPriceBreak(priceBreaks, qty) {
        var matchingPrice = priceBreaks.find(function (p) {
          return p.priceBreakLowerBound <= qty && (!p.priceBreakUpperBound || p.priceBreakUpperBound >= qty);
        });
        if (matchingPrice) return matchingPrice.priceExVatWithoutCurrencySymbol;
        console.log('No matching pricebreak for qty ' + qty);
        return priceBreaks[0].priceExVatWithoutCurrencySymbol;
      }

      // Send search beacon
      window.getGbTracker().sendAddToCartEvent({
        id: RS.Utils.Cookies.getCookie('cart'), // XXX This won't work if cart has not been initialized
        items: [{
          productId: this.state.productNumber,
          title: this.state.name,
          price: getPriceBreak(this.state.priceBreaks, this.state.quantity),
          currency: this.state.productPrice.currencyCode,
          quantity: itemQuantity,
          // eslint-disable-next-line no-underscore-dangle
          collection: window.getGbTracker().__getInternals().AREA, // Not sure if there is a better way of getting this
          category: '', // TODO Something like 'AA rechargeable batteries' - get from breadcrumb because not in state?
          sku: this.state.manufacturerPartNumber
        }],
        experiments: []
      });
    }
  }, {
    key: 'modalAddedToBasketFunc',
    value: function modalAddedToBasketFunc() {
      var self = this;
      return function (qty) {
        return self.sendAddBeacon(qty);
      };
    }
  }, {
    key: 'addedToBasket',
    value: function addedToBasket() {
      this.setState({
        hasAddedToBasket: true,
        displayPackSizeWarning: false
      });
      this.sendAddBeacon(this.state.quantity);
    }
  }, {
    key: 'closeCheckStockModal',
    value: function closeCheckStockModal() {
      this.setState({
        showCheckStockModal: false
      });
    }
  }, {
    key: 'multiplesWarningFormatted',
    value: function multiplesWarningFormatted() {
      return this.state.labels.multiplesWarning.replace(/##SSM##/g, this.state.packSize);
    }
  }, {
    key: 'handlePartsListClick',
    value: function handlePartsListClick() {
      if (this.state.saveToPartsListLinkUrl) {
        window.location.assign(this.state.saveToPartsListLinkUrl);
      } else {
        this.setState({
          showPartsListModal: true
        });
      }
    }
  }, {
    key: 'closePartsListModal',
    value: function closePartsListModal() {
      this.setState({
        showPartsListModal: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showCheckStockModal = _state.showCheckStockModal,
          showPartsListModal = _state.showPartsListModal;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.PriceBreak, {
          colSize: this.state.colSize,
          labels: this.state.labels,
          showIndicativePrices: this.state.showIndicativePrices,
          priceBreaks: this.state.priceBreaks,
          quantity: this.state.quantity,
          packSize: this.state.packSize,
          productPrice: this.state.productPrice,
          isCustomerSpecificPricing: this.state.isCustomerSpecificPricing,
          energyEfficiencyRating: this.state.energyEfficiencyRating,
          energyProductInfoSheet: this.state.energyProductInfoSheet,
          energyEfficiencyRatingText: this.state.energyEfficiencyRatingText,
          energyEfficiencyImage: this.state.energyEfficiencyImage
        }),
        _react2.default.createElement(
          'div',
          { className: 'addToCartRTQContainer' },
          this.state.restrictions.hasRestrictions() && _react2.default.createElement(
            'div',
            { className: 'product-restrictions-container' },
            _react2.default.createElement(
              'div',
              { className: 'customer-display-text' },
              this.state.customerDisplayText
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-text' },
              this.state.infoText
            )
          ),
          !this.state.restrictions.barred && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.state.displayPackSizeWarning && _react2.default.createElement(
              'div',
              { className: 'quantity-warning-container' },
              _react2.default.createElement(
                'div',
                { className: 'quantity-warning-text' },
                this.multiplesWarningFormatted()
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'priceQuantity' },
              _react2.default.createElement(_components.InputSpinner, {
                initialQuantity: this.state.initialQuantity,
                packSize: this.state.packSize,
                maximumQuantity: this.state.maximumQuantity,
                onUpdateQuantity: function onUpdateQuantity(quantity) {
                  return _this3.quantityUpdated(quantity);
                }
              }),
              _react2.default.createElement(
                'div',
                { className: 'text-units' },
                this.state.labels.rangeHeaderLabel
              ),
              _react2.default.createElement(
                'div',
                { className: 'add-to-basket-container' },
                _react2.default.createElement(_components.AddToBasketButton, {
                  label: this.state.labels.addToCart,
                  stockNumber: this.state.stockNumber,
                  quantity: this.state.quantity,
                  onAddedToBasket: function onAddedToBasket() {
                    return _this3.addedToBasket();
                  },
                  packSize: this.state.packSize,
                  onPackSizeError: function onPackSizeError() {
                    return _this3.displayPackSizeWarning();
                  },
                  disabled: this.state.restrictBackOrder || this.state.promiseNoAddToCart || this.state.promiseCannotBackOrder && this.state.quantity > this.state.promiseQuantity
                })
              ),
              this.state.hasAddedToBasket && _react2.default.createElement(
                'div',
                { className: 'cart-added page-cart-added' },
                _react2.default.createElement('i', { className: 'icon icon-rs_57-tick', 'aria-hidden': 'true' }),
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.labels.addedToCart
                ),
                _react2.default.createElement(_components.ViewBasketButton, {
                  label: this.state.labels.viewBasket,
                  redirectUrl: this.state.basketUrl
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'ck-lead-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'float-left ck-stock-container' },
                  this.state.showRealTimeQuantityChecker && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'a',
                      {
                        className: 'check-stock-level-link',
                        role: 'button',
                        onClick: function onClick() {
                          _this3.setState({
                            showCheckStockModal: !showCheckStockModal
                          });
                        },
                        tabIndex: -1,
                        disabled: this.state.promiseNoAddToCart
                      },
                      this.state.labels.realTimeQuantityChecker
                    ),
                    _react2.default.createElement(
                      _reactAddonsCssTransitionGroup2.default,
                      { transitionName: 'fade', transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
                      showCheckStockModal && _react2.default.createElement(
                        _Modal2.default,
                        {
                          key: 1,
                          header: 'My Modal',
                          open: showCheckStockModal,
                          onClose: this.closeCheckStockModal,
                          showFooter: false,
                          title: this.state.labels.checkStock.modalTitle
                        },
                        _react2.default.createElement(_components.CheckStockModal, {
                          initialQuantity: this.state.quantity,
                          maximumQuantity: this.state.maximumQuantity,
                          stockNumber: this.state.stockNumber,
                          productNumber: this.state.productNumber,
                          productId: this.state.productId,
                          labels: this.state.labels.checkStock,
                          closeModal: this.closeCheckStockModal,
                          basketUrl: this.state.basketUrl,
                          onAddToBasket: this.modalAddedToBasketFunc()
                        })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'float-right save-partslist-container' },
                  _react2.default.createElement(
                    'a',
                    { className: 'save-partslist-link', onClick: this.handlePartsListClick, role: 'button', tabIndex: -1 },
                    _react2.default.createElement('i', { className: 'icon icon-rs_52-star-stroke' }),
                    _react2.default.createElement(
                      'span',
                      null,
                      this.state.labels.addToAPartsList
                    )
                  ),
                  _react2.default.createElement(
                    _reactAddonsCssTransitionGroup2.default,
                    { transitionName: 'fade', transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
                    showPartsListModal && _react2.default.createElement(
                      _Modal2.default,
                      {
                        key: 1,
                        header: 'My Modal',
                        open: showPartsListModal,
                        onClose: this.closePartsListModal,
                        showFooter: false,
                        title: this.state.labels.addToAPartsList
                      },
                      _react2.default.createElement(_components.PartsListModal, {
                        contextPath: this.state.contextPath,
                        name: this.state.name,
                        manufacturerPartNumber: this.state.manufacturerPartNumber,
                        productNumber: this.state.productNumber,
                        initialQuantity: this.state.initialQuantity,
                        maximumQuantity: this.state.maximumQuantity,
                        stockNumber: this.state.stockNumber,
                        labels: this.state.labels.partsList,
                        closeModal: this.closePartsListModal
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return InputSpinnerContainer;
}(_react2.default.Component);

exports.default = InputSpinnerContainer;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cookies = __webpack_require__(220);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Cookies2.default;
module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(221);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(222);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _utils = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = function () {
  function Cookies(cookies, hooks) {
    _classCallCheck(this, Cookies);

    this.cookies = parseCookies(cookies);
    this.hooks = hooks;
    this.HAS_DOCUMENT_COOKIE = (0, _utils.hasDocumentCookie)();
  }

  _createClass(Cookies, [{
    key: '_updateBrowserValues',
    value: function _updateBrowserValues() {
      if (!this.HAS_DOCUMENT_COOKIE) {
        return;
      }

      this.cookies = _cookie2.default.parse(document.cookie);
    }
  }, {
    key: 'get',
    value: function get(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this._updateBrowserValues();
      return readCookie(this.cookies[name], options);
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._updateBrowserValues();
      var result = {};

      for (var name in this.cookies) {
        result[name] = readCookie(this.cookies[name], options);
      }

      return result;
    }
  }, {
    key: 'set',
    value: function set(name, value, options) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        value = JSON.stringify(value);
      }

      if (this.hooks && this.hooks.onSet) {
        this.hooks.onSet(name, value, options);
      }

      this.cookies[name] = value;

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, value, options);
      }
    }
  }, {
    key: 'remove',
    value: function remove(name, options) {
      var finalOptions = options = (0, _objectAssign2.default)({}, options, {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: 0
      });

      if (this.hooks && this.hooks.onRemove) {
        this.hooks.onRemove(name, finalOptions);
      }

      delete this.cookies[name];

      if (this.HAS_DOCUMENT_COOKIE) {
        document.cookie = _cookie2.default.serialize(name, '', finalOptions);
      }
    }
  }]);

  return Cookies;
}();

exports.default = Cookies;


function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return _cookie2.default.parse(cookies);
  } else if ((typeof cookies === 'undefined' ? 'undefined' : _typeof(cookies)) === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isParsingCookie(value, options.doNotParse)) {
    try {
      return JSON.parse(value);
    } catch (e) {
      // At least we tried
    }
  }

  return value;
}
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.hasDocumentCookie = hasDocumentCookie;
exports.cleanCookies = cleanCookies;
// Can we get/set cookies on document.cookie?

function hasDocumentCookie() {
  return (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && typeof document.cookie === 'string';
}

//backwards compatibility
var HAS_DOCUMENT_COOKIE = exports.HAS_DOCUMENT_COOKIE = hasDocumentCookie();

function cleanCookies() {
  document.cookie.split(';').forEach(function (c) {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

var _QueryString = __webpack_require__(58);

var _SearchMessage = __webpack_require__(225);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchMessageContainer = function (_React$Component) {
  _inherits(SearchMessageContainer, _React$Component);

  function SearchMessageContainer(props) {
    _classCallCheck(this, SearchMessageContainer);

    var _this = _possibleConstructorReturn(this, (SearchMessageContainer.__proto__ || Object.getPrototypeOf(SearchMessageContainer)).call(this, props));

    var rsWebProductModel = window.rs.web.product.model;
    var messages = { noResultsFound: undefined, showingResultsFor: undefined };
    var relevancyData = 'relevancy-data';

    if (window.location.search && window.location.search.indexOf(relevancyData)) {
      var items = (0, _QueryString.SplitQueryString)();
      messages = (0, _SearchMessage.GetSearchMessage)(items[relevancyData]);
    }
    _this.state = { messages: messages, labels: rsWebProductModel.labels.search };
    return _this;
  }

  _createClass(SearchMessageContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.SearchMessage, { messages: this.state.messages, labels: this.state.labels });
    }
  }]);

  return SearchMessageContainer;
}(_react2.default.Component);

exports.default = SearchMessageContainer;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetSearchMessage = GetSearchMessage;

var _HexDecoder = __webpack_require__(93);

var _QueryString = __webpack_require__(58);

function GetSearchMessage(hexString) {
  if (!hexString) {
    return { noResultsFound: undefined, showingResultsFor: undefined };
  }

  var decodedString = (0, _HexDecoder.DecodeHex)(hexString);
  if (!decodedString) {
    return { noResultsFound: undefined, showingResultsFor: undefined };
  }

  var searchMessageParams = (0, _QueryString.SplitQueryString)(decodedString);

  return {
    noResultsFound: searchMessageParams['sta'],
    showingResultsFor: searchMessageParams['sa']
  };
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactAddonsCssTransitionGroup = __webpack_require__(21);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

var _services = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkedProductContainer = function (_Component) {
  _inherits(LinkedProductContainer, _Component);

  function LinkedProductContainer(props) {
    _classCallCheck(this, LinkedProductContainer);

    var _this = _possibleConstructorReturn(this, (LinkedProductContainer.__proto__ || Object.getPrototypeOf(LinkedProductContainer)).call(this, props));

    _this.handleClick = function () {
      window.location.assign('' + _this.state.compareScreenUrl + _this.state.productNumber + '/');
    };

    _this.closePopup = function () {
      _this.setState({
        showPopup: false
      });
    };

    var rsWebProductModel = window.rs.web.product.model;
    Object.keys(rsWebProductModel.labels.linkedProducts).forEach(function (key) {
      rsWebProductModel.labels.linkedProducts[key] = (0, _services.HtmlEntitiesDecode)(rsWebProductModel.labels.linkedProducts[key]);
    });
    _this.state = {
      masterProductStockNumber: rsWebProductModel.stockNumber,
      linkedProducts: rsWebProductModel.linkedProducts,
      labels: rsWebProductModel.labels.linkedProducts,
      contextPath: rsWebProductModel.contextPath,
      name: (0, _services.HtmlEntitiesDecode)(rsWebProductModel.name),
      showPopup: true,
      productNumber: rsWebProductModel.productNumber,
      compareScreenUrl: rsWebProductModel.isDiscontinued ? '/web/cpd/' : '/web/cpo/'
    };
    return _this;
  }

  _createClass(LinkedProductContainer, [{
    key: 'productNameFormatted',
    value: function productNameFormatted() {
      return this.state.labels.productNamePlaceholder.replace(/###/g, this.state.name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.state.linkedProducts && this.state.linkedProducts.length > 0 && _react2.default.createElement(
        'div',
        { className: 'linked-products' },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'fade',
            transitionAppear: true,
            transitionAppearTimeout: 500,
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 300
          },
          this.state.showPopup && _react2.default.createElement(
            'div',
            { className: 'linked-product-popup' },
            _react2.default.createElement(
              _components.Popup,
              { open: this.state.showPopup, onClose: this.closePopup },
              _react2.default.createElement(
                'p',
                { className: 'linked-product-heading' },
                this.productNameFormatted()
              ),
              _react2.default.createElement(
                'p',
                null,
                this.state.labels.hereIsOur
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'linked-products-header-container' },
          _react2.default.createElement(
            'div',
            { className: 'linked-products-header' },
            this.state.labels.alternativeProducts
          ),
          _react2.default.createElement(
            'div',
            { className: 'linked-product-compare' },
            _react2.default.createElement(
              'a',
              {
                role: 'button',
                className: 'btn btn-secondary-blue',
                tabIndex: '-1',
                onClick: this.handleClick
              },
              this.state.labels.compare
            )
          )
        ),
        this.state.linkedProducts.map(function (item) {
          return _react2.default.createElement(_components.LinkedProduct, _extends({
            key: item.id
          }, item, {
            labels: _this2.state.labels,
            contextPath: _this2.state.contextPath
          }));
        })
      );
    }
  }]);

  return LinkedProductContainer;
}(_react.Component);

exports.default = LinkedProductContainer;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactAddonsCssTransitionGroup = __webpack_require__(21);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _services = __webpack_require__(13);

var _Modal = __webpack_require__(31);

var _Modal2 = _interopRequireDefault(_Modal);

var _TechnicalDocumentModal = __webpack_require__(97);

var _TechnicalDocumentModal2 = _interopRequireDefault(_TechnicalDocumentModal);

var _TechinicalDocumentState = __webpack_require__(228);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TechnicalDocumentContainer = function (_Component) {
  _inherits(TechnicalDocumentContainer, _Component);

  function TechnicalDocumentContainer(props) {
    _classCallCheck(this, TechnicalDocumentContainer);

    var _this = _possibleConstructorReturn(this, (TechnicalDocumentContainer.__proto__ || Object.getPrototypeOf(TechnicalDocumentContainer)).call(this, props));

    _this.state = (0, _TechinicalDocumentState.initialState)();

    _this.openModal = _this.openModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }

  _createClass(TechnicalDocumentContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (this.state.productDataLibraryUrl === null || this.state.productDataLibraryUrl === undefined) return;
      (0, _services.GetProductDataLibrary)(this.state.productDataLibraryUrl).then(function (data) {
        _this2.setState((0, _TechinicalDocumentState.buildState)({
          state: _this2.state,
          data: data
        }));
        _this2.checkForTechnicalDocuments();
      }, function () {});
    }
  }, {
    key: 'checkForTechnicalDocuments',
    value: function checkForTechnicalDocuments() {
      if (this.state.documentCount === 0 && this.state.technicalDocumentsNotFound) {
        var technicalReferenceElement = document.getElementsByClassName('TechnicalReference')[0];
        technicalReferenceElement.parentNode.removeChild(technicalReferenceElement);
      }
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.documentCount > 0 && this.state.documentCount <= 2 && _react2.default.createElement(
          'div',
          { className: 'technical-row row download data-library-less' },
          this.state.documents.map(function (document) {
            return _react2.default.createElement(
              'div',
              { className: 'col-xs-6', key: document.id },
              _react2.default.createElement('span', { className: 'icon icon-rs_137-zip' }),
              _react2.default.createElement(
                'a',
                { href: document.href },
                document.title
              )
            );
          })
        ),
        this.state.documentCount > 2 && _react2.default.createElement(
          'div',
          { className: 'technical-row row download data-library-more' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6' },
            _react2.default.createElement('span', null),
            _react2.default.createElement(
              'a',
              { tabIndex: '-1', role: 'button', className: 'data-library-link', onClick: this.openModal },
              _react2.default.createElement('i', { className: 'icon icon-rs_56-text-open', 'aria-hidden': 'true' }),
              this.state.labels.exploreAllDocuments
            )
          )
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'fade', transitionEnterTimeout: 500, transitionLeaveTimeout: 300 },
          this.state.showModal && _react2.default.createElement(
            _Modal2.default,
            {
              key: 1,
              className: 'data-library-dialog',
              header: 'My Modal',
              open: this.state.showModal,
              onClose: this.closeModal,
              showFooter: false,
              title: this.state.documents.length + ' ' + this.state.labels.for + ' ' + this.state.name
            },
            _react2.default.createElement(_TechnicalDocumentModal2.default, {
              closeModal: this.closeModal,
              documents: this.state.documents,
              dateFormat: this.state.dateFormat,
              labels: this.state.labels
            })
          )
        )
      );
    }
  }]);

  return TechnicalDocumentContainer;
}(_react.Component);

exports.default = TechnicalDocumentContainer;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildState = exports.initialState = undefined;

var _services = __webpack_require__(13);

var createDocHref = function createDocHref(document, state) {
  var baseUrl = state.productDataLibraryUrl.substring(0, state.productDataLibraryUrl.indexOf('/', state.productDataLibraryUrl.indexOf('//') + 2));
  return '' + baseUrl + document.revisions.path + '.' + document.revisions.extension;
};

var getValidDocumentsWithLatestRevision = function getValidDocumentsWithLatestRevision(documents, state) {
  var validDocuments = documents.filter(function (document) {
    return state.excludedFileTypes.indexOf(document.type) === -1 && document.title != null;
  });
  validDocuments.forEach(function (document) {
    document.revisions = document.revisions && document.revisions[document.latestRevision - 1];
    if (document.revisions && state.productDataLibraryUrl) {
      document.revisions.created = (0, _services.FormatDate)(new Date(document.revisions.created * 1000), state.dateFormat);
      document.href = createDocHref(document, state);
    }
  });
  return validDocuments;
};

var buildState = function buildState(_ref) {
  var state = _ref.state,
      data = _ref.data;

  state.documents = data && data.results ? getValidDocumentsWithLatestRevision(data.results, state) : null;
  state.documentCount = state.documents ? state.documents.length : 0;
  return state;
};

var initialState = function initialState() {
  var rsWebProductModel = window.rs.web.product.model;
  return {
    productNumber: rsWebProductModel.productNumber,
    name: rsWebProductModel.name,
    productDataLibraryUrl: rsWebProductModel.productDataLibraryUrl ? rsWebProductModel.productDataLibraryUrl.replace('##PRODUCTNUMBER##', rsWebProductModel.productNumber).replace('http:', '') : null,
    excludedFileTypes: rsWebProductModel.excludedFileTypes,
    labels: rsWebProductModel.labels.technicalDocuments,
    documents: null,
    documentCount: null,
    showModal: false,
    dateFormat: rsWebProductModel.dateFormat,
    technicalDocumentsNotFound: rsWebProductModel.technicalDocumentsNotFound
  };
};

exports.initialState = initialState;
exports.buildState = buildState;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelatedCategoryContainer = function (_React$Component) {
  _inherits(RelatedCategoryContainer, _React$Component);

  function RelatedCategoryContainer(props) {
    _classCallCheck(this, RelatedCategoryContainer);

    var _this = _possibleConstructorReturn(this, (RelatedCategoryContainer.__proto__ || Object.getPrototypeOf(RelatedCategoryContainer)).call(this, props));

    _this.defaultHeight = '40px';

    _this.showHide = function () {
      return _this.setState(function (state) {
        return {
          accordionHeight: !state.isExpanded ? state.actualHeight : _this.defaultHeight,
          isExpanded: !state.isExpanded
        };
      });
    };

    var rsWebProductModel = window.rs.web.product.model;
    _this.state = {
      labels: rsWebProductModel.labels,
      relatedCategories: rsWebProductModel.relatedCategories,
      showShowHideLink: false,
      accordionHeight: 'initial',
      isExpanded: false,
      actualHeight: null
    };
    return _this;
  }

  _createClass(RelatedCategoryContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.getClientHeight();
      if (height > 40) {
        this.setState({ accordionHeight: this.defaultHeight, showShowHideLink: true, actualHeight: height });
      }
    }
  }, {
    key: 'getClientHeight',
    value: function getClientHeight() {
      if (this.divElement) {
        return this.divElement.clientHeight;
      }
      return 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.state.relatedCategories && this.state.relatedCategories.length > 0 && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'product-relatedcategories-heading' },
          this.state.labels.relatedCategories
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'read-more-wrap',
            style: { height: this.state.accordionHeight },
            ref: function ref(divElement) {
              _this2.divElement = divElement;
            }
          },
          this.state.relatedCategories.map(function (item) {
            return _react2.default.createElement(_components.RelatedCategory, _extends({ key: item.categoryName }, item));
          })
        ),
        this.state.showShowHideLink && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'a',
            { role: 'button', tabIndex: -99999, onClick: this.showHide, className: 'read-more-trigger' },
            this.state.isExpanded ? this.state.labels.showLess : this.state.labels.showMore
          ),
          _react2.default.createElement('span', { className: 'related-category-chevron ' + (!this.state.isExpanded ? 'more' : 'less') })
        )
      );
    }
  }]);

  return RelatedCategoryContainer;
}(_react2.default.Component);

exports.default = RelatedCategoryContainer;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalibratedProductContainer = function (_Component) {
  _inherits(CalibratedProductContainer, _Component);

  function CalibratedProductContainer(props) {
    _classCallCheck(this, CalibratedProductContainer);

    var _this = _possibleConstructorReturn(this, (CalibratedProductContainer.__proto__ || Object.getPrototypeOf(CalibratedProductContainer)).call(this, props));

    var productLogoTexts = [{ regex: /RS CAL|RSCAL/, text: 'RS CAL' }, { regex: /UKAS CAL|UKAS/, text: 'UKAS CAL' }, { regex: /SYS CAL|SYSCAL/, text: 'SYS CAL' }];
    var rsWebProductModel = window.rs.web.product.model;
    var labels = window.rs.web.product.model.labels.calibratedProducts;
    var calibratedProducts = rsWebProductModel.calibratedProducts.map(function (item) {
      var productLogoText = productLogoTexts.find(function (v) {
        return v.regex.test(item.description.toUpperCase());
      });

      productLogoText = productLogoText != null ? productLogoText.text : 'CAL';
      return _extends({}, item, { productLogoText: productLogoText });
    });

    _this.state = {
      calibratedProducts: calibratedProducts,
      labels: labels
    };
    return _this;
  }

  _createClass(CalibratedProductContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'calibrated-products' },
        this.state.calibratedProducts.map(function (item) {
          return _react2.default.createElement(_components.CalibratedProduct, _extends({}, item, { labels: _this2.state.labels, key: item.id }));
        })
      );
    }
  }]);

  return CalibratedProductContainer;
}(_react.Component);

exports.default = CalibratedProductContainer;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(55);

var _ImageCarousel = __webpack_require__(232);

var _ImageCarousel2 = _interopRequireDefault(_ImageCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducer = (0, _redux.combineReducers)({
  ImageCarousel: _ImageCarousel2.default
});

exports.default = reducer;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return state;
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _initialState = __webpack_require__(234);

Object.defineProperty(exports, 'initialImageCarouselState', {
  enumerable: true,
  get: function get() {
    return _initialState.initialImageCarouselState;
  }
});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var rsWebProductModel = window.rs.web.product.model;
var initialImageCarouselState = exports.initialImageCarouselState = {
  ImageCarousel: {
    images: rsWebProductModel.images,
    maxCarouselSize: rsWebProductModel.maxCarouselSize,
    shared: {
      isShared: rsWebProductModel.shared.isShared,
      sharedMessage: rsWebProductModel.shared.sharedMessage
    },
    video: {
      thumbnailURL: rsWebProductModel.video.thumbnailURL,
      videoURL: rsWebProductModel.video.videoURL
    },
    vfmFlagImages: rsWebProductModel.vfmFlagImages,
    selectedImageIndex: 0,
    currentPosition: 0,
    isVideoDisplayed: false,
    is360Display: rsWebProductModel.is360Display,
    productGalleryContentCloudName: rsWebProductModel.productGalleryContentCloudName,
    productNumber: rsWebProductModel.productNumber
  }
};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// product.min.js